
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire25bc"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire25bc"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
// src/index.ts
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $defa8edbc79437a8$var$__assign = function() {
    $defa8edbc79437a8$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $defa8edbc79437a8$var$__assign.apply(this, arguments);
};
var $defa8edbc79437a8$export$1efaef7de3802058 = /** @class */ function() {
    function NotyfNotification(options) {
        this.options = options;
        this.listeners = {};
    }
    NotyfNotification.prototype.on = function(eventType, cb) {
        var callbacks = this.listeners[eventType] || [];
        this.listeners[eventType] = callbacks.concat([
            cb
        ]);
    };
    NotyfNotification.prototype.triggerEvent = function(eventType, event) {
        var _this = this;
        var callbacks = this.listeners[eventType] || [];
        callbacks.forEach(function(cb) {
            return cb({
                target: _this,
                event: event
            });
        });
    };
    return NotyfNotification;
}();
var $defa8edbc79437a8$export$2324fc501d2ffc65;
(function(NotyfArrayEvent) {
    NotyfArrayEvent[NotyfArrayEvent["Add"] = 0] = "Add";
    NotyfArrayEvent[NotyfArrayEvent["Remove"] = 1] = "Remove";
})($defa8edbc79437a8$export$2324fc501d2ffc65 || ($defa8edbc79437a8$export$2324fc501d2ffc65 = {}));
var $defa8edbc79437a8$export$7763ebb8bf460cea = /** @class */ function() {
    function NotyfArray() {
        this.notifications = [];
    }
    NotyfArray.prototype.push = function(elem) {
        this.notifications.push(elem);
        this.updateFn(elem, $defa8edbc79437a8$export$2324fc501d2ffc65.Add, this.notifications);
    };
    NotyfArray.prototype.splice = function(index, num) {
        var elem = this.notifications.splice(index, num)[0];
        this.updateFn(elem, $defa8edbc79437a8$export$2324fc501d2ffc65.Remove, this.notifications);
        return elem;
    };
    NotyfArray.prototype.indexOf = function(elem) {
        return this.notifications.indexOf(elem);
    };
    NotyfArray.prototype.onUpdate = function(fn) {
        this.updateFn = fn;
    };
    return NotyfArray;
}();
var $defa8edbc79437a8$export$776308576d349339;
(function(NotyfEvent) {
    NotyfEvent["Dismiss"] = "dismiss";
    NotyfEvent["Click"] = "click";
})($defa8edbc79437a8$export$776308576d349339 || ($defa8edbc79437a8$export$776308576d349339 = {}));
var $defa8edbc79437a8$export$93ca5d3f8675ae4c = {
    types: [
        {
            type: "success",
            className: "notyf__toast--success",
            backgroundColor: "#3dc763",
            icon: {
                className: "notyf__icon--success",
                tagName: "i"
            }
        },
        {
            type: "error",
            className: "notyf__toast--error",
            backgroundColor: "#ed3d3d",
            icon: {
                className: "notyf__icon--error",
                tagName: "i"
            }
        }
    ],
    duration: 2000,
    ripple: true,
    position: {
        x: "right",
        y: "bottom"
    },
    dismissible: false
};
var $defa8edbc79437a8$export$75d30b0f81ca0e5f = /** @class */ function() {
    function NotyfView() {
        this.notifications = [];
        this.events = {};
        this.X_POSITION_FLEX_MAP = {
            left: "flex-start",
            center: "center",
            right: "flex-end"
        };
        this.Y_POSITION_FLEX_MAP = {
            top: "flex-start",
            center: "center",
            bottom: "flex-end"
        };
        // Creates the main notifications container
        var docFrag = document.createDocumentFragment();
        var notyfContainer = this._createHTMLElement({
            tagName: "div",
            className: "notyf"
        });
        docFrag.appendChild(notyfContainer);
        document.body.appendChild(docFrag);
        this.container = notyfContainer;
        // Identifies the main animation end event
        this.animationEndEventName = this._getAnimationEndEventName();
        this._createA11yContainer();
    }
    NotyfView.prototype.on = function(event, cb) {
        var _a;
        this.events = $defa8edbc79437a8$var$__assign($defa8edbc79437a8$var$__assign({}, this.events), (_a = {}, _a[event] = cb, _a));
    };
    NotyfView.prototype.update = function(notification, type) {
        if (type === $defa8edbc79437a8$export$2324fc501d2ffc65.Add) this.addNotification(notification);
        else if (type === $defa8edbc79437a8$export$2324fc501d2ffc65.Remove) this.removeNotification(notification);
    };
    NotyfView.prototype.removeNotification = function(notification) {
        var _this = this;
        var renderedNotification = this._popRenderedNotification(notification);
        var node;
        if (!renderedNotification) return;
        node = renderedNotification.node;
        node.classList.add("notyf__toast--disappear");
        var handleEvent;
        node.addEventListener(this.animationEndEventName, handleEvent = function(event) {
            if (event.target === node) {
                node.removeEventListener(_this.animationEndEventName, handleEvent);
                _this.container.removeChild(node);
            }
        });
    };
    NotyfView.prototype.addNotification = function(notification) {
        var node = this._renderNotification(notification);
        this.notifications.push({
            notification: notification,
            node: node
        });
        // For a11y purposes, we still want to announce that there's a notification in the screen
        // even if it comes with no message.
        this._announce(notification.options.message || "Notification");
    };
    NotyfView.prototype._renderNotification = function(notification) {
        var _a;
        var card = this._buildNotificationCard(notification);
        var className = notification.options.className;
        if (className) (_a = card.classList).add.apply(_a, className.split(" "));
        this.container.appendChild(card);
        return card;
    };
    NotyfView.prototype._popRenderedNotification = function(notification) {
        var idx = -1;
        for(var i = 0; i < this.notifications.length && idx < 0; i++)if (this.notifications[i].notification === notification) idx = i;
        if (idx !== -1) return this.notifications.splice(idx, 1)[0];
        return;
    };
    NotyfView.prototype.getXPosition = function(options) {
        var _a;
        return ((_a = options === null || options === void 0 ? void 0 : options.position) === null || _a === void 0 ? void 0 : _a.x) || "right";
    };
    NotyfView.prototype.getYPosition = function(options) {
        var _a;
        return ((_a = options === null || options === void 0 ? void 0 : options.position) === null || _a === void 0 ? void 0 : _a.y) || "bottom";
    };
    NotyfView.prototype.adjustContainerAlignment = function(options) {
        var align = this.X_POSITION_FLEX_MAP[this.getXPosition(options)];
        var justify = this.Y_POSITION_FLEX_MAP[this.getYPosition(options)];
        var style = this.container.style;
        style.setProperty("justify-content", justify);
        style.setProperty("align-items", align);
    };
    NotyfView.prototype._buildNotificationCard = function(notification) {
        var _this = this;
        var options = notification.options;
        var iconOpts = options.icon;
        // Adjust container according to position (e.g. top-left, bottom-center, etc)
        this.adjustContainerAlignment(options);
        // Create elements
        var notificationElem = this._createHTMLElement({
            tagName: "div",
            className: "notyf__toast"
        });
        var ripple = this._createHTMLElement({
            tagName: "div",
            className: "notyf__ripple"
        });
        var wrapper = this._createHTMLElement({
            tagName: "div",
            className: "notyf__wrapper"
        });
        var message = this._createHTMLElement({
            tagName: "div",
            className: "notyf__message"
        });
        message.innerHTML = options.message || "";
        var mainColor = options.background || options.backgroundColor;
        // Build the icon and append it to the card
        if (iconOpts) {
            var iconContainer = this._createHTMLElement({
                tagName: "div",
                className: "notyf__icon"
            });
            if (typeof iconOpts === "string" || iconOpts instanceof String) iconContainer.innerHTML = new String(iconOpts).valueOf();
            if (typeof iconOpts === "object") {
                var _a = iconOpts.tagName, tagName = _a === void 0 ? "i" : _a, className_1 = iconOpts.className, text = iconOpts.text, _b = iconOpts.color, color = _b === void 0 ? mainColor : _b;
                var iconElement = this._createHTMLElement({
                    tagName: tagName,
                    className: className_1,
                    text: text
                });
                if (color) iconElement.style.color = color;
                iconContainer.appendChild(iconElement);
            }
            wrapper.appendChild(iconContainer);
        }
        wrapper.appendChild(message);
        notificationElem.appendChild(wrapper);
        // Add ripple if applicable, else just paint the full toast
        if (mainColor) {
            if (options.ripple) {
                ripple.style.background = mainColor;
                notificationElem.appendChild(ripple);
            } else notificationElem.style.background = mainColor;
        }
        // Add dismiss button
        if (options.dismissible) {
            var dismissWrapper = this._createHTMLElement({
                tagName: "div",
                className: "notyf__dismiss"
            });
            var dismissButton = this._createHTMLElement({
                tagName: "button",
                className: "notyf__dismiss-btn"
            });
            dismissWrapper.appendChild(dismissButton);
            wrapper.appendChild(dismissWrapper);
            notificationElem.classList.add("notyf__toast--dismissible");
            dismissButton.addEventListener("click", function(event) {
                var _a, _b;
                (_b = (_a = _this.events)[$defa8edbc79437a8$export$776308576d349339.Dismiss]) === null || _b === void 0 || _b.call(_a, {
                    target: notification,
                    event: event
                });
                event.stopPropagation();
            });
        }
        notificationElem.addEventListener("click", function(event) {
            var _a, _b;
            return (_b = (_a = _this.events)[$defa8edbc79437a8$export$776308576d349339.Click]) === null || _b === void 0 ? void 0 : _b.call(_a, {
                target: notification,
                event: event
            });
        });
        // Adjust margins depending on whether its an upper or lower notification
        var className = this.getYPosition(options) === "top" ? "upper" : "lower";
        notificationElem.classList.add("notyf__toast--" + className);
        return notificationElem;
    };
    NotyfView.prototype._createHTMLElement = function(_a) {
        var tagName = _a.tagName, className = _a.className, text = _a.text;
        var elem = document.createElement(tagName);
        if (className) elem.className = className;
        elem.textContent = text || null;
        return elem;
    };
    /**
     * Creates an invisible container which will announce the notyfs to
     * screen readers
     */ NotyfView.prototype._createA11yContainer = function() {
        var a11yContainer = this._createHTMLElement({
            tagName: "div",
            className: "notyf-announcer"
        });
        a11yContainer.setAttribute("aria-atomic", "true");
        a11yContainer.setAttribute("aria-live", "polite");
        // Set the a11y container to be visible hidden. Can't use display: none as
        // screen readers won't read it.
        a11yContainer.style.border = "0";
        a11yContainer.style.clip = "rect(0 0 0 0)";
        a11yContainer.style.height = "1px";
        a11yContainer.style.margin = "-1px";
        a11yContainer.style.overflow = "hidden";
        a11yContainer.style.padding = "0";
        a11yContainer.style.position = "absolute";
        a11yContainer.style.width = "1px";
        a11yContainer.style.outline = "0";
        document.body.appendChild(a11yContainer);
        this.a11yContainer = a11yContainer;
    };
    /**
     * Announces a message to screenreaders.
     */ NotyfView.prototype._announce = function(message) {
        var _this = this;
        this.a11yContainer.textContent = "";
        // This 100ms timeout is necessary for some browser + screen-reader combinations:
        // - Both JAWS and NVDA over IE11 will not announce anything without a non-zero timeout.
        // - With Chrome and IE11 with NVDA or JAWS, a repeated (identical) message won't be read a
        //   second time without clearing and then using a non-zero delay.
        // (using JAWS 17 at time of this writing).
        // https://github.com/angular/material2/blob/master/src/cdk/a11y/live-announcer/live-announcer.ts
        setTimeout(function() {
            _this.a11yContainer.textContent = message;
        }, 100);
    };
    /**
     * Determine which animationend event is supported
     */ NotyfView.prototype._getAnimationEndEventName = function() {
        var el = document.createElement("_fake");
        var transitions = {
            MozTransition: "animationend",
            OTransition: "oAnimationEnd",
            WebkitTransition: "webkitAnimationEnd",
            transition: "animationend"
        };
        var t;
        for(t in transitions){
            if (el.style[t] !== undefined) return transitions[t];
        }
        // No supported animation end event. Using "animationend" as a fallback
        return "animationend";
    };
    return NotyfView;
}();
/**
 * Main controller class. Defines the main Notyf API.
 */ var $defa8edbc79437a8$export$146ebdf5fc143718 = /** @class */ function() {
    function Notyf(opts) {
        var _this = this;
        this.dismiss = this._removeNotification;
        this.notifications = new $defa8edbc79437a8$export$7763ebb8bf460cea();
        this.view = new $defa8edbc79437a8$export$75d30b0f81ca0e5f();
        var types = this.registerTypes(opts);
        this.options = $defa8edbc79437a8$var$__assign($defa8edbc79437a8$var$__assign({}, $defa8edbc79437a8$export$93ca5d3f8675ae4c), opts);
        this.options.types = types;
        this.notifications.onUpdate(function(elem, type) {
            return _this.view.update(elem, type);
        });
        this.view.on($defa8edbc79437a8$export$776308576d349339.Dismiss, function(_a) {
            var target = _a.target, event = _a.event;
            _this._removeNotification(target);
            // tslint:disable-next-line: no-string-literal
            target["triggerEvent"]($defa8edbc79437a8$export$776308576d349339.Dismiss, event);
        });
        // tslint:disable-next-line: no-string-literal
        this.view.on($defa8edbc79437a8$export$776308576d349339.Click, function(_a) {
            var target = _a.target, event = _a.event;
            return target["triggerEvent"]($defa8edbc79437a8$export$776308576d349339.Click, event);
        });
    }
    Notyf.prototype.error = function(payload) {
        var options = this.normalizeOptions("error", payload);
        return this.open(options);
    };
    Notyf.prototype.success = function(payload) {
        var options = this.normalizeOptions("success", payload);
        return this.open(options);
    };
    Notyf.prototype.open = function(options) {
        var defaultOpts = this.options.types.find(function(_a) {
            var type = _a.type;
            return type === options.type;
        }) || {};
        var config = $defa8edbc79437a8$var$__assign($defa8edbc79437a8$var$__assign({}, defaultOpts), options);
        this.assignProps([
            "ripple",
            "position",
            "dismissible"
        ], config);
        var notification = new $defa8edbc79437a8$export$1efaef7de3802058(config);
        this._pushNotification(notification);
        return notification;
    };
    Notyf.prototype.dismissAll = function() {
        while(this.notifications.splice(0, 1));
    };
    /**
     * Assigns properties to a config object based on two rules:
     * 1. If the config object already sets that prop, leave it as so
     * 2. Otherwise, use the default prop from the global options
     *
     * It's intended to build the final config object to open a notification. e.g. if
     * 'dismissible' is not set, then use the value from the global config.
     *
     * @param props - properties to be assigned to the config object
     * @param config - object whose properties need to be set
     */ Notyf.prototype.assignProps = function(props, config) {
        var _this = this;
        props.forEach(function(prop) {
            // intentional double equality to check for both null and undefined
            config[prop] = config[prop] == null ? _this.options[prop] : config[prop];
        });
    };
    Notyf.prototype._pushNotification = function(notification) {
        var _this = this;
        this.notifications.push(notification);
        var duration = notification.options.duration !== undefined ? notification.options.duration : this.options.duration;
        if (duration) setTimeout(function() {
            return _this._removeNotification(notification);
        }, duration);
    };
    Notyf.prototype._removeNotification = function(notification) {
        var index = this.notifications.indexOf(notification);
        if (index !== -1) this.notifications.splice(index, 1);
    };
    Notyf.prototype.normalizeOptions = function(type, payload) {
        var options = {
            type: type
        };
        if (typeof payload === "string") options.message = payload;
        else if (typeof payload === "object") options = $defa8edbc79437a8$var$__assign($defa8edbc79437a8$var$__assign({}, options), payload);
        return options;
    };
    Notyf.prototype.registerTypes = function(opts) {
        var incomingTypes = (opts && opts.types || []).slice();
        var finalDefaultTypes = $defa8edbc79437a8$export$93ca5d3f8675ae4c.types.map(function(defaultType) {
            // find if there's a default type within the user input's types, if so, it means the user
            // wants to change some of the default settings
            var userTypeIdx = -1;
            incomingTypes.forEach(function(t, idx) {
                if (t.type === defaultType.type) userTypeIdx = idx;
            });
            var userType = userTypeIdx !== -1 ? incomingTypes.splice(userTypeIdx, 1)[0] : {};
            return $defa8edbc79437a8$var$__assign($defa8edbc79437a8$var$__assign({}, defaultType), userType);
        });
        return finalDefaultTypes.concat(incomingTypes);
    };
    return Notyf;
}();




var $800sp = parcelRequire("800sp");

var $4OBpG = parcelRequire("4OBpG");
var $4006d917b9e9fa13$var$_dec, $4006d917b9e9fa13$var$_dec2, $4006d917b9e9fa13$var$_dec3, $4006d917b9e9fa13$var$_class, $4006d917b9e9fa13$var$_class2, $4006d917b9e9fa13$var$_descriptor, $4006d917b9e9fa13$var$_descriptor2, $4006d917b9e9fa13$var$_AppNotification;
function $4006d917b9e9fa13$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $4006d917b9e9fa13$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer && (Object.defineProperty(i, e, a), a = null), a;
}
function $4006d917b9e9fa13$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $4006d917b9e9fa13$export$28c07ec5970f9da8 = ($4006d917b9e9fa13$var$_dec = (0, $4OBpG.customElement)("app-notification"), $4006d917b9e9fa13$var$_dec2 = (0, $4OBpG.property)({
    type: String
}), $4006d917b9e9fa13$var$_dec3 = (0, $4OBpG.property)({
    type: String
}), $4006d917b9e9fa13$var$_dec($4006d917b9e9fa13$var$_class = ($4006d917b9e9fa13$var$_class2 = ($4006d917b9e9fa13$var$_AppNotification = class AppNotification extends (0, $800sp.LitElement) {
    constructor(...args){
        super(...args);
        $4006d917b9e9fa13$var$_initializerDefineProperty(this, "message", $4006d917b9e9fa13$var$_descriptor, this);
        // 'info', 'success', 'error', 'warning'
        $4006d917b9e9fa13$var$_initializerDefineProperty(this, "type", $4006d917b9e9fa13$var$_descriptor2, this);
    }
    render() {
        return (0, $800sp.html)`
      <div class=${this.type}>${this.message}</div>
    `;
    }
}, $4006d917b9e9fa13$var$_AppNotification.styles = (0, $800sp.css)`
    :host {
      display: block;
      position: fixed;
      top: 1rem;
      right: 1rem;
      padding: 1rem;
      border-radius: 5px;
      color: white;
      z-index: 1000;
      transition: opacity 0.5s ease-in-out;
    }
    :host([hidden]) {
      display: none;
    }
    .info {
      background-color: #2196f3;
    }
    .success {
      background-color: #4caf50;
    }
    .error {
      background-color: #f44336;
    }
    .warning {
      background-color: #ff9800;
    }
  `, $4006d917b9e9fa13$var$_AppNotification), $4006d917b9e9fa13$var$_descriptor = $4006d917b9e9fa13$var$_applyDecoratedDescriptor($4006d917b9e9fa13$var$_class2.prototype, "message", [
    $4006d917b9e9fa13$var$_dec2
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "";
    }
}), $4006d917b9e9fa13$var$_descriptor2 = $4006d917b9e9fa13$var$_applyDecoratedDescriptor($4006d917b9e9fa13$var$_class2.prototype, "type", [
    $4006d917b9e9fa13$var$_dec3
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "info";
    }
}), $4006d917b9e9fa13$var$_class2)) || $4006d917b9e9fa13$var$_class);


function $f9d9d110dea7aeee$var$toArray(objectOrArray) {
    objectOrArray = objectOrArray || [];
    return Array.isArray(objectOrArray) ? objectOrArray : [
        objectOrArray
    ];
}
function $f9d9d110dea7aeee$var$log(msg) {
    return `[Vaadin.Router] ${msg}`;
}
function $f9d9d110dea7aeee$var$logValue(value) {
    if (typeof value !== "object") return String(value);
    const stringType = Object.prototype.toString.call(value).match(/ (.*)\]$/)[1];
    if (stringType === "Object" || stringType === "Array") return `${stringType} ${JSON.stringify(value)}`;
    else return stringType;
}
const $f9d9d110dea7aeee$var$MODULE = "module";
const $f9d9d110dea7aeee$var$NOMODULE = "nomodule";
const $f9d9d110dea7aeee$var$bundleKeys = [
    $f9d9d110dea7aeee$var$MODULE,
    $f9d9d110dea7aeee$var$NOMODULE
];
function $f9d9d110dea7aeee$var$ensureBundle(src) {
    if (!src.match(/.+\.[m]?js$/)) throw new Error($f9d9d110dea7aeee$var$log(`Unsupported type for bundle "${src}": .js or .mjs expected.`));
}
function $f9d9d110dea7aeee$var$ensureRoute(route) {
    if (!route || !$f9d9d110dea7aeee$var$isString(route.path)) throw new Error($f9d9d110dea7aeee$var$log(`Expected route config to be an object with a "path" string property, or an array of such objects`));
    const bundle = route.bundle;
    const stringKeys = [
        "component",
        "redirect",
        "bundle"
    ];
    if (!$f9d9d110dea7aeee$var$isFunction(route.action) && !Array.isArray(route.children) && !$f9d9d110dea7aeee$var$isFunction(route.children) && !$f9d9d110dea7aeee$var$isObject(bundle) && !stringKeys.some((key)=>$f9d9d110dea7aeee$var$isString(route[key]))) throw new Error($f9d9d110dea7aeee$var$log(`Expected route config "${route.path}" to include either "${stringKeys.join('", "')}" ` + `or "action" function but none found.`));
    if (bundle) {
        if ($f9d9d110dea7aeee$var$isString(bundle)) $f9d9d110dea7aeee$var$ensureBundle(bundle);
        else if (!$f9d9d110dea7aeee$var$bundleKeys.some((key)=>key in bundle)) throw new Error($f9d9d110dea7aeee$var$log('Expected route bundle to include either "' + $f9d9d110dea7aeee$var$NOMODULE + '" or "' + $f9d9d110dea7aeee$var$MODULE + '" keys, or both'));
        else $f9d9d110dea7aeee$var$bundleKeys.forEach((key)=>key in bundle && $f9d9d110dea7aeee$var$ensureBundle(bundle[key]));
    }
    if (route.redirect) [
        "bundle",
        "component"
    ].forEach((overriddenProp)=>{
        if (overriddenProp in route) console.warn($f9d9d110dea7aeee$var$log(`Route config "${route.path}" has both "redirect" and "${overriddenProp}" properties, ` + `and "redirect" will always override the latter. Did you mean to only use "${overriddenProp}"?`));
    });
}
function $f9d9d110dea7aeee$var$ensureRoutes(routes) {
    $f9d9d110dea7aeee$var$toArray(routes).forEach((route)=>$f9d9d110dea7aeee$var$ensureRoute(route));
}
function $f9d9d110dea7aeee$var$loadScript(src, key) {
    let script = document.head.querySelector('script[src="' + src + '"][async]');
    if (!script) {
        script = document.createElement("script");
        script.setAttribute("src", src);
        if (key === $f9d9d110dea7aeee$var$MODULE) script.setAttribute("type", $f9d9d110dea7aeee$var$MODULE);
        else if (key === $f9d9d110dea7aeee$var$NOMODULE) script.setAttribute($f9d9d110dea7aeee$var$NOMODULE, "");
        script.async = true;
    }
    return new Promise((resolve, reject)=>{
        script.onreadystatechange = script.onload = (e)=>{
            script.__dynamicImportLoaded = true;
            resolve(e);
        };
        script.onerror = (e)=>{
            if (script.parentNode) script.parentNode.removeChild(script);
            reject(e);
        };
        if (script.parentNode === null) document.head.appendChild(script);
        else if (script.__dynamicImportLoaded) resolve();
    });
}
function $f9d9d110dea7aeee$var$loadBundle(bundle) {
    if ($f9d9d110dea7aeee$var$isString(bundle)) return $f9d9d110dea7aeee$var$loadScript(bundle);
    else return Promise.race($f9d9d110dea7aeee$var$bundleKeys.filter((key)=>key in bundle).map((key)=>$f9d9d110dea7aeee$var$loadScript(bundle[key], key)));
}
function $f9d9d110dea7aeee$var$fireRouterEvent(type, detail) {
    return !window.dispatchEvent(new CustomEvent(`vaadin-router-${type}`, {
        cancelable: type === "go",
        detail: detail
    }));
}
function $f9d9d110dea7aeee$var$isObject(o) {
    // guard against null passing the typeof check
    return typeof o === "object" && !!o;
}
function $f9d9d110dea7aeee$var$isFunction(f) {
    return typeof f === "function";
}
function $f9d9d110dea7aeee$var$isString(s) {
    return typeof s === "string";
}
function $f9d9d110dea7aeee$var$getNotFoundError(context) {
    const error = new Error($f9d9d110dea7aeee$var$log(`Page not found (${context.pathname})`));
    error.context = context;
    error.code = 404;
    return error;
}
const $f9d9d110dea7aeee$var$notFoundResult = new class NotFoundResult {
}();
/* istanbul ignore next: coverage is calculated in Chrome, this code is for IE */ function $f9d9d110dea7aeee$var$getAnchorOrigin(anchor) {
    // IE11: on HTTP and HTTPS the default port is not included into
    // window.location.origin, so won't include it here either.
    const port = anchor.port;
    const protocol = anchor.protocol;
    const defaultHttp = protocol === "http:" && port === "80";
    const defaultHttps = protocol === "https:" && port === "443";
    const host = defaultHttp || defaultHttps ? anchor.hostname // does not include the port number (e.g. www.example.org)
     : anchor.host; // does include the port number (e.g. www.example.org:80)
    return `${protocol}//${host}`;
}
// The list of checks is not complete:
//  - SVG support is missing
//  - the 'rel' attribute is not considered
function $f9d9d110dea7aeee$var$vaadinRouterGlobalClickHandler(event) {
    // ignore the click if the default action is prevented
    if (event.defaultPrevented) return;
    // ignore the click if not with the primary mouse button
    if (event.button !== 0) return;
    // ignore the click if a modifier key is pressed
    if (event.shiftKey || event.ctrlKey || event.altKey || event.metaKey) return;
    // find the <a> element that the click is at (or within)
    let anchor = event.target;
    const path = event.composedPath ? event.composedPath() : event.path || [];
    // FIXME(web-padawan): `Symbol.iterator` used by webcomponentsjs is broken for arrays
    // example to check: `for...of` loop here throws the "Not yet implemented" error
    for(let i = 0; i < path.length; i++){
        const target = path[i];
        if (target.nodeName && target.nodeName.toLowerCase() === "a") {
            anchor = target;
            break;
        }
    }
    while(anchor && anchor.nodeName.toLowerCase() !== "a")anchor = anchor.parentNode;
    // ignore the click if not at an <a> element
    if (!anchor || anchor.nodeName.toLowerCase() !== "a") return;
    // ignore the click if the <a> element has a non-default target
    if (anchor.target && anchor.target.toLowerCase() !== "_self") return;
    // ignore the click if the <a> element has the 'download' attribute
    if (anchor.hasAttribute("download")) return;
    // ignore the click if the <a> element has the 'router-ignore' attribute
    if (anchor.hasAttribute("router-ignore")) return;
    // ignore the click if the target URL is a fragment on the current page
    if (anchor.pathname === window.location.pathname && anchor.hash !== "") return;
    // ignore the click if the target is external to the app
    // In IE11 HTMLAnchorElement does not have the `origin` property
    const origin = anchor.origin || $f9d9d110dea7aeee$var$getAnchorOrigin(anchor);
    if (origin !== window.location.origin) return;
    // if none of the above, convert the click into a navigation event
    const { pathname: pathname, search: search, hash: hash } = anchor;
    if ($f9d9d110dea7aeee$var$fireRouterEvent("go", {
        pathname: pathname,
        search: search,
        hash: hash
    })) {
        event.preventDefault();
        // for a click event, the scroll is reset to the top position.
        if (event && event.type === "click") window.scrollTo(0, 0);
    }
}
/**
 * A navigation trigger for Vaadin Router that translated clicks on `<a>` links
 * into Vaadin Router navigation events.
 *
 * Only regular clicks on in-app links are translated (primary mouse button, no
 * modifier keys, the target href is within the app's URL space).
 *
 * @memberOf Router.NavigationTrigger
 * @type {NavigationTrigger}
 */ const $f9d9d110dea7aeee$var$CLICK = {
    activate () {
        window.document.addEventListener("click", $f9d9d110dea7aeee$var$vaadinRouterGlobalClickHandler);
    },
    inactivate () {
        window.document.removeEventListener("click", $f9d9d110dea7aeee$var$vaadinRouterGlobalClickHandler);
    }
};
// PopStateEvent constructor shim
const $f9d9d110dea7aeee$var$isIE = /Trident/.test(navigator.userAgent);
/* istanbul ignore next: coverage is calculated in Chrome, this code is for IE */ if ($f9d9d110dea7aeee$var$isIE && !$f9d9d110dea7aeee$var$isFunction(window.PopStateEvent)) {
    window.PopStateEvent = function(inType, params) {
        params = params || {};
        var e = document.createEvent("Event");
        e.initEvent(inType, Boolean(params.bubbles), Boolean(params.cancelable));
        e.state = params.state || null;
        return e;
    };
    window.PopStateEvent.prototype = window.Event.prototype;
}
function $f9d9d110dea7aeee$var$vaadinRouterGlobalPopstateHandler(event) {
    if (event.state === "vaadin-router-ignore") return;
    const { pathname: pathname, search: search, hash: hash } = window.location;
    $f9d9d110dea7aeee$var$fireRouterEvent("go", {
        pathname: pathname,
        search: search,
        hash: hash
    });
}
/**
 * A navigation trigger for Vaadin Router that translates popstate events into
 * Vaadin Router navigation events.
 *
 * @memberOf Router.NavigationTrigger
 * @type {NavigationTrigger}
 */ const $f9d9d110dea7aeee$var$POPSTATE = {
    activate () {
        window.addEventListener("popstate", $f9d9d110dea7aeee$var$vaadinRouterGlobalPopstateHandler);
    },
    inactivate () {
        window.removeEventListener("popstate", $f9d9d110dea7aeee$var$vaadinRouterGlobalPopstateHandler);
    }
};
/**
 * Expose `pathToRegexp`.
 */ var $f9d9d110dea7aeee$var$pathToRegexp_1 = $f9d9d110dea7aeee$var$pathToRegexp$1;
var $f9d9d110dea7aeee$var$parse_1 = $f9d9d110dea7aeee$var$parse;
var $f9d9d110dea7aeee$var$compile_1 = $f9d9d110dea7aeee$var$compile;
var $f9d9d110dea7aeee$var$tokensToFunction_1 = $f9d9d110dea7aeee$var$tokensToFunction;
var $f9d9d110dea7aeee$var$tokensToRegExp_1 = $f9d9d110dea7aeee$var$tokensToRegExp;
/**
 * Default configs.
 */ var $f9d9d110dea7aeee$var$DEFAULT_DELIMITER = "/";
var $f9d9d110dea7aeee$var$DEFAULT_DELIMITERS = "./";
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $f9d9d110dea7aeee$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    "(\\\\.)",
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // ":test(\\d+)?" => ["test", "\d+", undefined, "?"]
    // "(\\d+)"  => [undefined, undefined, "\d+", undefined]
    "(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?"
].join("|"), "g");
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $f9d9d110dea7aeee$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = "";
    var defaultDelimiter = options && options.delimiter || $f9d9d110dea7aeee$var$DEFAULT_DELIMITER;
    var delimiters = options && options.delimiters || $f9d9d110dea7aeee$var$DEFAULT_DELIMITERS;
    var pathEscaped = false;
    var res;
    while((res = $f9d9d110dea7aeee$var$PATH_REGEXP.exec(str)) !== null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            pathEscaped = true;
            continue;
        }
        var prev = "";
        var next = str[index];
        var name = res[2];
        var capture = res[3];
        var group = res[4];
        var modifier = res[5];
        if (!pathEscaped && path.length) {
            var k = path.length - 1;
            if (delimiters.indexOf(path[k]) > -1) {
                prev = path[k];
                path = path.slice(0, k);
            }
        }
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = "";
            pathEscaped = false;
        }
        var partial = prev !== "" && next !== undefined && next !== prev;
        var repeat = modifier === "+" || modifier === "*";
        var optional = modifier === "?" || modifier === "*";
        var delimiter = prev || defaultDelimiter;
        var pattern = capture || group;
        tokens.push({
            name: name || key++,
            prefix: prev,
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            pattern: pattern ? $f9d9d110dea7aeee$var$escapeGroup(pattern) : "[^" + $f9d9d110dea7aeee$var$escapeString(delimiter) + "]+?"
        });
    }
    // Push any remaining characters.
    if (path || index < str.length) tokens.push(path + str.substr(index));
    return tokens;
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $f9d9d110dea7aeee$var$compile(str, options) {
    return $f9d9d110dea7aeee$var$tokensToFunction($f9d9d110dea7aeee$var$parse(str, options));
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $f9d9d110dea7aeee$var$tokensToFunction(tokens) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === "object") matches[i] = new RegExp("^(?:" + tokens[i].pattern + ")$");
    return function(data, options) {
        var path = "";
        var encode = options && options.encode || encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data ? data[token.name] : undefined;
            var segment;
            if (Array.isArray(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but got array');
                if (value.length === 0) {
                    if (token.optional) continue;
                    throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j], token);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '"');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
                segment = encode(String(value), token);
                if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but got "' + segment + '"');
                path += token.prefix + segment;
                continue;
            }
            if (token.optional) {
                // Prepend partial segment prefixes.
                if (token.partial) path += token.prefix;
                continue;
            }
            throw new TypeError('Expected "' + token.name + '" to be ' + (token.repeat ? "an array" : "a string"));
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $f9d9d110dea7aeee$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $f9d9d110dea7aeee$var$escapeGroup(group) {
    return group.replace(/([=!:$/()])/g, "\\$1");
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $f9d9d110dea7aeee$var$flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {Array=}  keys
 * @return {!RegExp}
 */ function $f9d9d110dea7aeee$var$regexpToRegexp(path, keys) {
    if (!keys) return path;
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        pattern: null
    });
    return path;
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array=}  keys
 * @param  {Object=} options
 * @return {!RegExp}
 */ function $f9d9d110dea7aeee$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($f9d9d110dea7aeee$var$pathToRegexp$1(path[i], keys, options).source);
    return new RegExp("(?:" + parts.join("|") + ")", $f9d9d110dea7aeee$var$flags(options));
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {Array=}  keys
 * @param  {Object=} options
 * @return {!RegExp}
 */ function $f9d9d110dea7aeee$var$stringToRegexp(path, keys, options) {
    return $f9d9d110dea7aeee$var$tokensToRegExp($f9d9d110dea7aeee$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}  tokens
 * @param  {Array=}  keys
 * @param  {Object=} options
 * @return {!RegExp}
 */ function $f9d9d110dea7aeee$var$tokensToRegExp(tokens, keys, options) {
    options = options || {};
    var strict = options.strict;
    var start = options.start !== false;
    var end = options.end !== false;
    var delimiter = $f9d9d110dea7aeee$var$escapeString(options.delimiter || $f9d9d110dea7aeee$var$DEFAULT_DELIMITER);
    var delimiters = options.delimiters || $f9d9d110dea7aeee$var$DEFAULT_DELIMITERS;
    var endsWith = [].concat(options.endsWith || []).map($f9d9d110dea7aeee$var$escapeString).concat("$").join("|");
    var route = start ? "^" : "";
    var isEndDelimited = tokens.length === 0;
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === "string") {
            route += $f9d9d110dea7aeee$var$escapeString(token);
            isEndDelimited = i === tokens.length - 1 && delimiters.indexOf(token[token.length - 1]) > -1;
        } else {
            var capture = token.repeat ? "(?:" + token.pattern + ")(?:" + $f9d9d110dea7aeee$var$escapeString(token.delimiter) + "(?:" + token.pattern + "))*" : token.pattern;
            if (keys) keys.push(token);
            if (token.optional) {
                if (token.partial) route += $f9d9d110dea7aeee$var$escapeString(token.prefix) + "(" + capture + ")?";
                else route += "(?:" + $f9d9d110dea7aeee$var$escapeString(token.prefix) + "(" + capture + "))?";
            } else route += $f9d9d110dea7aeee$var$escapeString(token.prefix) + "(" + capture + ")";
        }
    }
    if (end) {
        if (!strict) route += "(?:" + delimiter + ")?";
        route += endsWith === "$" ? "$" : "(?=" + endsWith + ")";
    } else {
        if (!strict) route += "(?:" + delimiter + "(?=" + endsWith + "))?";
        if (!isEndDelimited) route += "(?=" + delimiter + "|" + endsWith + ")";
    }
    return new RegExp(route, $f9d9d110dea7aeee$var$flags(options));
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {Array=}                keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $f9d9d110dea7aeee$var$pathToRegexp$1(path, keys, options) {
    if (path instanceof RegExp) return $f9d9d110dea7aeee$var$regexpToRegexp(path, keys);
    if (Array.isArray(path)) return $f9d9d110dea7aeee$var$arrayToRegexp(/** @type {!Array} */ path, keys, options);
    return $f9d9d110dea7aeee$var$stringToRegexp(/** @type {string} */ path, keys, options);
}
$f9d9d110dea7aeee$var$pathToRegexp_1.parse = $f9d9d110dea7aeee$var$parse_1;
$f9d9d110dea7aeee$var$pathToRegexp_1.compile = $f9d9d110dea7aeee$var$compile_1;
$f9d9d110dea7aeee$var$pathToRegexp_1.tokensToFunction = $f9d9d110dea7aeee$var$tokensToFunction_1;
$f9d9d110dea7aeee$var$pathToRegexp_1.tokensToRegExp = $f9d9d110dea7aeee$var$tokensToRegExp_1;
/**
 * Universal Router (https://www.kriasoft.com/universal-router/)
 *
 * Copyright (c) 2015-present Kriasoft.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */ const { hasOwnProperty: $f9d9d110dea7aeee$var$hasOwnProperty } = Object.prototype;
const $f9d9d110dea7aeee$var$cache$1 = new Map();
// see https://github.com/pillarjs/path-to-regexp/issues/148
$f9d9d110dea7aeee$var$cache$1.set("|false", {
    keys: [],
    pattern: /(?:)/
});
function $f9d9d110dea7aeee$var$decodeParam(val) {
    try {
        return decodeURIComponent(val);
    } catch (err) {
        return val;
    }
}
function $f9d9d110dea7aeee$var$matchPath(routepath, path, exact, parentKeys, parentParams) {
    exact = !!exact;
    const cacheKey = `${routepath}|${exact}`;
    let regexp = $f9d9d110dea7aeee$var$cache$1.get(cacheKey);
    if (!regexp) {
        const keys = [];
        regexp = {
            keys: keys,
            pattern: $f9d9d110dea7aeee$var$pathToRegexp_1(routepath, keys, {
                end: exact,
                strict: routepath === ""
            })
        };
        $f9d9d110dea7aeee$var$cache$1.set(cacheKey, regexp);
    }
    const m = regexp.pattern.exec(path);
    if (!m) return null;
    const params = Object.assign({}, parentParams);
    for(let i = 1; i < m.length; i++){
        const key = regexp.keys[i - 1];
        const prop = key.name;
        const value = m[i];
        if (value !== undefined || !$f9d9d110dea7aeee$var$hasOwnProperty.call(params, prop)) {
            if (key.repeat) params[prop] = value ? value.split(key.delimiter).map($f9d9d110dea7aeee$var$decodeParam) : [];
            else params[prop] = value ? $f9d9d110dea7aeee$var$decodeParam(value) : value;
        }
    }
    return {
        path: m[0],
        keys: (parentKeys || []).concat(regexp.keys),
        params: params
    };
}
/**
 * Universal Router (https://www.kriasoft.com/universal-router/)
 *
 * Copyright (c) 2015-present Kriasoft.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */ /**
 * Traverses the routes tree and matches its nodes to the given pathname from
 * the root down to the leaves. Each match consumes a part of the pathname and
 * the matching process continues for as long as there is a matching child
 * route for the remaining part of the pathname.
 *
 * The returned value is a lazily evaluated iterator.
 *
 * The leading "/" in a route path matters only for the root of the routes
 * tree (or if all parent routes are ""). In all other cases a leading "/" in
 * a child route path has no significance.
 *
 * The trailing "/" in a _route path_ matters only for the leaves of the
 * routes tree. A leaf route with a trailing "/" matches only a pathname that
 * also has a trailing "/".
 *
 * The trailing "/" in a route path does not affect matching of child routes
 * in any way.
 *
 * The trailing "/" in a _pathname_ generally does not matter (except for
 * the case of leaf nodes described above).
 *
 * The "" and "/" routes have special treatment:
 *  1. as a single route
 *     the "" and "/" routes match only the "" and "/" pathnames respectively
 *  2. as a parent in the routes tree
 *     the "" route matches any pathname without consuming any part of it
 *     the "/" route matches any absolute pathname consuming its leading "/"
 *  3. as a leaf in the routes tree
 *     the "" and "/" routes match only if the entire pathname is consumed by
 *         the parent routes chain. In this case "" and "/" are equivalent.
 *  4. several directly nested "" or "/" routes
 *     - directly nested "" or "/" routes are 'squashed' (i.e. nesting two
 *       "/" routes does not require a double "/" in the pathname to match)
 *     - if there are only "" in the parent routes chain, no part of the
 *       pathname is consumed, and the leading "/" in the child routes' paths
 *       remains significant
 *
 * Side effect:
 *   - the routes tree { path: '' } matches only the '' pathname
 *   - the routes tree { path: '', children: [ { path: '' } ] } matches any
 *     pathname (for the tree root)
 *
 * Prefix matching can be enabled also by `children: true`.
 */ function $f9d9d110dea7aeee$var$matchRoute(route, pathname, ignoreLeadingSlash, parentKeys, parentParams) {
    let match;
    let childMatches;
    let childIndex = 0;
    let routepath = route.path || "";
    if (routepath.charAt(0) === "/") {
        if (ignoreLeadingSlash) routepath = routepath.substr(1);
        ignoreLeadingSlash = true;
    }
    return {
        next (routeToSkip) {
            if (route === routeToSkip) return {
                done: true
            };
            const children = route.__children = route.__children || route.children;
            if (!match) {
                match = $f9d9d110dea7aeee$var$matchPath(routepath, pathname, !children, parentKeys, parentParams);
                if (match) return {
                    done: false,
                    value: {
                        route: route,
                        keys: match.keys,
                        params: match.params,
                        path: match.path
                    }
                };
            }
            if (match && children) while(childIndex < children.length){
                if (!childMatches) {
                    const childRoute = children[childIndex];
                    childRoute.parent = route;
                    let matchedLength = match.path.length;
                    if (matchedLength > 0 && pathname.charAt(matchedLength) === "/") matchedLength += 1;
                    childMatches = $f9d9d110dea7aeee$var$matchRoute(childRoute, pathname.substr(matchedLength), ignoreLeadingSlash, match.keys, match.params);
                }
                const childMatch = childMatches.next(routeToSkip);
                if (!childMatch.done) return {
                    done: false,
                    value: childMatch.value
                };
                childMatches = null;
                childIndex++;
            }
            return {
                done: true
            };
        }
    };
}
/**
 * Universal Router (https://www.kriasoft.com/universal-router/)
 *
 * Copyright (c) 2015-present Kriasoft.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */ function $f9d9d110dea7aeee$var$resolveRoute(context) {
    if ($f9d9d110dea7aeee$var$isFunction(context.route.action)) return context.route.action(context);
    return undefined;
}
/**
 * Universal Router (https://www.kriasoft.com/universal-router/)
 *
 * Copyright (c) 2015-present Kriasoft.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */ function $f9d9d110dea7aeee$var$isChildRoute(parentRoute, childRoute) {
    let route = childRoute;
    while(route){
        route = route.parent;
        if (route === parentRoute) return true;
    }
    return false;
}
function $f9d9d110dea7aeee$var$generateErrorMessage(currentContext) {
    let errorMessage = `Path '${currentContext.pathname}' is not properly resolved due to an error.`;
    const routePath = (currentContext.route || {}).path;
    if (routePath) errorMessage += ` Resolution had failed on route: '${routePath}'`;
    return errorMessage;
}
function $f9d9d110dea7aeee$var$updateChainForRoute(context, match) {
    const { route: route, path: path } = match;
    if (route && !route.__synthetic) {
        const item = {
            path: path,
            route: route
        };
        if (!context.chain) context.chain = [];
        else // Discard old items
        if (route.parent) {
            let i = context.chain.length;
            while(i-- && context.chain[i].route && context.chain[i].route !== route.parent)context.chain.pop();
        }
        context.chain.push(item);
    }
}
/**
 */ class $f9d9d110dea7aeee$export$8b4c839865b08288 {
    constructor(routes, options = {}){
        if (Object(routes) !== routes) throw new TypeError("Invalid routes");
        this.baseUrl = options.baseUrl || "";
        this.errorHandler = options.errorHandler;
        this.resolveRoute = options.resolveRoute || $f9d9d110dea7aeee$var$resolveRoute;
        this.context = Object.assign({
            resolver: this
        }, options.context);
        this.root = Array.isArray(routes) ? {
            path: "",
            __children: routes,
            parent: null,
            __synthetic: true
        } : routes;
        this.root.parent = null;
    }
    /**
   * Returns the current list of routes (as a shallow copy). Adding / removing
   * routes to / from the returned array does not affect the routing config,
   * but modifying the route objects does.
   *
   * @return {!Array<!Router.Route>}
   */ getRoutes() {
        return [
            ...this.root.__children
        ];
    }
    /**
   * Sets the routing config (replacing the existing one).
   *
   * @param {!Array<!Router.Route>|!Router.Route} routes a single route or an array of those
   *    (the array is shallow copied)
   */ setRoutes(routes) {
        $f9d9d110dea7aeee$var$ensureRoutes(routes);
        const newRoutes = [
            ...$f9d9d110dea7aeee$var$toArray(routes)
        ];
        this.root.__children = newRoutes;
    }
    /**
   * Appends one or several routes to the routing config and returns the
   * effective routing config after the operation.
   *
   * @param {!Array<!Router.Route>|!Router.Route} routes a single route or an array of those
   *    (the array is shallow copied)
   * @return {!Array<!Router.Route>}
   * @protected
   */ addRoutes(routes) {
        $f9d9d110dea7aeee$var$ensureRoutes(routes);
        this.root.__children.push(...$f9d9d110dea7aeee$var$toArray(routes));
        return this.getRoutes();
    }
    /**
   * Removes all existing routes from the routing config.
   */ removeRoutes() {
        this.setRoutes([]);
    }
    /**
   * Asynchronously resolves the given pathname, i.e. finds all routes matching
   * the pathname and tries resolving them one after another in the order they
   * are listed in the routes config until the first non-null result.
   *
   * Returns a promise that is fulfilled with the return value of an object that consists of the first
   * route handler result that returns something other than `null` or `undefined` and context used to get this result.
   *
   * If no route handlers return a non-null result, or if no route matches the
   * given pathname the returned promise is rejected with a 'page not found'
   * `Error`.
   *
   * @param {!string|!{pathname: !string}} pathnameOrContext the pathname to
   *    resolve or a context object with a `pathname` property and other
   *    properties to pass to the route resolver functions.
   * @return {!Promise<any>}
   */ resolve(pathnameOrContext) {
        const context = Object.assign({}, this.context, $f9d9d110dea7aeee$var$isString(pathnameOrContext) ? {
            pathname: pathnameOrContext
        } : pathnameOrContext);
        const match = $f9d9d110dea7aeee$var$matchRoute(this.root, this.__normalizePathname(context.pathname), this.baseUrl);
        const resolve = this.resolveRoute;
        let matches = null;
        let nextMatches = null;
        let currentContext = context;
        function next(resume, parent = matches.value.route, prevResult) {
            const routeToSkip = prevResult === null && matches.value.route;
            matches = nextMatches || match.next(routeToSkip);
            nextMatches = null;
            if (!resume) {
                if (matches.done || !$f9d9d110dea7aeee$var$isChildRoute(parent, matches.value.route)) {
                    nextMatches = matches;
                    return Promise.resolve($f9d9d110dea7aeee$var$notFoundResult);
                }
            }
            if (matches.done) return Promise.reject($f9d9d110dea7aeee$var$getNotFoundError(context));
            currentContext = Object.assign(currentContext ? {
                chain: currentContext.chain ? currentContext.chain.slice(0) : []
            } : {}, context, matches.value);
            $f9d9d110dea7aeee$var$updateChainForRoute(currentContext, matches.value);
            return Promise.resolve(resolve(currentContext)).then((resolution)=>{
                if (resolution !== null && resolution !== undefined && resolution !== $f9d9d110dea7aeee$var$notFoundResult) {
                    currentContext.result = resolution.result || resolution;
                    return currentContext;
                }
                return next(resume, parent, resolution);
            });
        }
        context.next = next;
        return Promise.resolve().then(()=>next(true, this.root)).catch((error)=>{
            const errorMessage = $f9d9d110dea7aeee$var$generateErrorMessage(currentContext);
            if (!error) error = new Error(errorMessage);
            else console.warn(errorMessage);
            error.context = error.context || currentContext;
            // DOMException has its own code which is read-only
            if (!(error instanceof DOMException)) error.code = error.code || 500;
            if (this.errorHandler) {
                currentContext.result = this.errorHandler(error);
                return currentContext;
            }
            throw error;
        });
    }
    /**
   * URL constructor polyfill hook. Creates and returns an URL instance.
   */ static __createUrl(url, base) {
        return new URL(url, base);
    }
    /**
   * If the baseUrl property is set, transforms the baseUrl and returns the full
   * actual `base` string for using in the `new URL(path, base);` and for
   * prepernding the paths with. The returned base ends with a trailing slash.
   *
   * Otherwise, returns empty string.
   */ get __effectiveBaseUrl() {
        return this.baseUrl ? this.constructor.__createUrl(this.baseUrl, document.baseURI || document.URL).href.replace(/[^\/]*$/, "") : "";
    }
    /**
   * If the baseUrl is set, matches the pathname with the router’s baseUrl,
   * and returns the local pathname with the baseUrl stripped out.
   *
   * If the pathname does not match the baseUrl, returns undefined.
   *
   * If the `baseUrl` is not set, returns the unmodified pathname argument.
   */ __normalizePathname(pathname) {
        if (!this.baseUrl) // No base URL, no need to transform the pathname.
        return pathname;
        const base = this.__effectiveBaseUrl;
        const normalizedUrl = this.constructor.__createUrl(pathname, base).href;
        if (normalizedUrl.slice(0, base.length) === base) return normalizedUrl.slice(base.length);
    }
}
$f9d9d110dea7aeee$export$8b4c839865b08288.pathToRegexp = $f9d9d110dea7aeee$var$pathToRegexp_1;
/**
 * Universal Router (https://www.kriasoft.com/universal-router/)
 *
 * Copyright (c) 2015-present Kriasoft.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */ const { pathToRegexp: $f9d9d110dea7aeee$var$pathToRegexp } = $f9d9d110dea7aeee$export$8b4c839865b08288;
const $f9d9d110dea7aeee$var$cache = new Map();
function $f9d9d110dea7aeee$var$cacheRoutes(routesByName, route, routes) {
    const name = route.name || route.component;
    if (name) {
        if (routesByName.has(name)) routesByName.get(name).push(route);
        else routesByName.set(name, [
            route
        ]);
    }
    if (Array.isArray(routes)) for(let i = 0; i < routes.length; i++){
        const childRoute = routes[i];
        childRoute.parent = route;
        $f9d9d110dea7aeee$var$cacheRoutes(routesByName, childRoute, childRoute.__children || childRoute.children);
    }
}
function $f9d9d110dea7aeee$var$getRouteByName(routesByName, routeName) {
    const routes = routesByName.get(routeName);
    if (routes && routes.length > 1) throw new Error(`Duplicate route with name "${routeName}".` + ` Try seting unique 'name' route properties.`);
    return routes && routes[0];
}
function $f9d9d110dea7aeee$var$getRoutePath(route) {
    let path = route.path;
    path = Array.isArray(path) ? path[0] : path;
    return path !== undefined ? path : "";
}
function $f9d9d110dea7aeee$var$generateUrls(router, options = {}) {
    if (!(router instanceof $f9d9d110dea7aeee$export$8b4c839865b08288)) throw new TypeError("An instance of Resolver is expected");
    const routesByName = new Map();
    return (routeName, params)=>{
        let route = $f9d9d110dea7aeee$var$getRouteByName(routesByName, routeName);
        if (!route) {
            routesByName.clear(); // clear cache
            $f9d9d110dea7aeee$var$cacheRoutes(routesByName, router.root, router.root.__children);
            route = $f9d9d110dea7aeee$var$getRouteByName(routesByName, routeName);
            if (!route) throw new Error(`Route "${routeName}" not found`);
        }
        let regexp = $f9d9d110dea7aeee$var$cache.get(route.fullPath);
        if (!regexp) {
            let fullPath = $f9d9d110dea7aeee$var$getRoutePath(route);
            let rt = route.parent;
            while(rt){
                const path = $f9d9d110dea7aeee$var$getRoutePath(rt);
                if (path) fullPath = path.replace(/\/$/, "") + "/" + fullPath.replace(/^\//, "");
                rt = rt.parent;
            }
            const tokens = $f9d9d110dea7aeee$var$pathToRegexp.parse(fullPath);
            const toPath = $f9d9d110dea7aeee$var$pathToRegexp.tokensToFunction(tokens);
            const keys = Object.create(null);
            for(let i = 0; i < tokens.length; i++)if (!$f9d9d110dea7aeee$var$isString(tokens[i])) keys[tokens[i].name] = true;
            regexp = {
                toPath: toPath,
                keys: keys
            };
            $f9d9d110dea7aeee$var$cache.set(fullPath, regexp);
            route.fullPath = fullPath;
        }
        let url = regexp.toPath(params, options) || "/";
        if (options.stringifyQueryParams && params) {
            const queryParams = {};
            const keys = Object.keys(params);
            for(let i = 0; i < keys.length; i++){
                const key = keys[i];
                if (!regexp.keys[key]) queryParams[key] = params[key];
            }
            const query = options.stringifyQueryParams(queryParams);
            if (query) url += query.charAt(0) === "?" ? query : `?${query}`;
        }
        return url;
    };
}
/**
 * @typedef NavigationTrigger
 * @type {object}
 * @property {function()} activate
 * @property {function()} inactivate
 */ /** @type {Array<NavigationTrigger>} */ let $f9d9d110dea7aeee$var$triggers = [];
function $f9d9d110dea7aeee$var$setNavigationTriggers(newTriggers) {
    $f9d9d110dea7aeee$var$triggers.forEach((trigger)=>trigger.inactivate());
    newTriggers.forEach((trigger)=>trigger.activate());
    $f9d9d110dea7aeee$var$triggers = newTriggers;
}
const $f9d9d110dea7aeee$var$willAnimate = (elem)=>{
    const name = getComputedStyle(elem).getPropertyValue("animation-name");
    return name && name !== "none";
};
const $f9d9d110dea7aeee$var$waitForAnimation = (elem, cb)=>{
    const listener = ()=>{
        elem.removeEventListener("animationend", listener);
        cb();
    };
    elem.addEventListener("animationend", listener);
};
function $f9d9d110dea7aeee$var$animate(elem, className) {
    elem.classList.add(className);
    return new Promise((resolve)=>{
        if ($f9d9d110dea7aeee$var$willAnimate(elem)) {
            const rect = elem.getBoundingClientRect();
            const size = `height: ${rect.bottom - rect.top}px; width: ${rect.right - rect.left}px`;
            elem.setAttribute("style", `position: absolute; ${size}`);
            $f9d9d110dea7aeee$var$waitForAnimation(elem, ()=>{
                elem.classList.remove(className);
                elem.removeAttribute("style");
                resolve();
            });
        } else {
            elem.classList.remove(className);
            resolve();
        }
    });
}
const $f9d9d110dea7aeee$var$MAX_REDIRECT_COUNT = 256;
function $f9d9d110dea7aeee$var$isResultNotEmpty(result) {
    return result !== null && result !== undefined;
}
function $f9d9d110dea7aeee$var$copyContextWithoutNext(context) {
    const copy = Object.assign({}, context);
    delete copy.next;
    return copy;
}
function $f9d9d110dea7aeee$var$createLocation({ pathname: pathname = "", search: search = "", hash: hash = "", chain: chain = [], params: params = {}, redirectFrom: redirectFrom, resolver: resolver }, route) {
    const routes = chain.map((item)=>item.route);
    return {
        baseUrl: resolver && resolver.baseUrl || "",
        pathname: pathname,
        search: search,
        hash: hash,
        routes: routes,
        route: route || routes.length && routes[routes.length - 1] || null,
        params: params,
        redirectFrom: redirectFrom,
        getUrl: (userParams = {})=>$f9d9d110dea7aeee$var$getPathnameForRouter($f9d9d110dea7aeee$export$55185c17a0fcbe46.pathToRegexp.compile($f9d9d110dea7aeee$var$getMatchedPath(routes))(Object.assign({}, params, userParams)), resolver)
    };
}
function $f9d9d110dea7aeee$var$createRedirect(context, pathname) {
    const params = Object.assign({}, context.params);
    return {
        redirect: {
            pathname: pathname,
            from: context.pathname,
            params: params
        }
    };
}
function $f9d9d110dea7aeee$var$renderElement(context, element) {
    element.location = $f9d9d110dea7aeee$var$createLocation(context);
    const index = context.chain.map((item)=>item.route).indexOf(context.route);
    context.chain[index].element = element;
    return element;
}
function $f9d9d110dea7aeee$var$runCallbackIfPossible(callback, args, thisArg) {
    if ($f9d9d110dea7aeee$var$isFunction(callback)) return callback.apply(thisArg, args);
}
function $f9d9d110dea7aeee$var$amend(amendmentFunction, args, element) {
    return (amendmentResult)=>{
        if (amendmentResult && (amendmentResult.cancel || amendmentResult.redirect)) return amendmentResult;
        if (element) return $f9d9d110dea7aeee$var$runCallbackIfPossible(element[amendmentFunction], args, element);
    };
}
function $f9d9d110dea7aeee$var$processNewChildren(newChildren, route) {
    if (!Array.isArray(newChildren) && !$f9d9d110dea7aeee$var$isObject(newChildren)) throw new Error($f9d9d110dea7aeee$var$log(`Incorrect "children" value for the route ${route.path}: expected array or object, but got ${newChildren}`));
    route.__children = [];
    const childRoutes = $f9d9d110dea7aeee$var$toArray(newChildren);
    for(let i = 0; i < childRoutes.length; i++){
        $f9d9d110dea7aeee$var$ensureRoute(childRoutes[i]);
        route.__children.push(childRoutes[i]);
    }
}
function $f9d9d110dea7aeee$var$removeDomNodes(nodes) {
    if (nodes && nodes.length) {
        const parent = nodes[0].parentNode;
        for(let i = 0; i < nodes.length; i++)parent.removeChild(nodes[i]);
    }
}
function $f9d9d110dea7aeee$var$getPathnameForRouter(pathname, router) {
    const base = router.__effectiveBaseUrl;
    return base ? router.constructor.__createUrl(pathname.replace(/^\//, ""), base).pathname : pathname;
}
function $f9d9d110dea7aeee$var$getMatchedPath(chain) {
    return chain.map((item)=>item.path).reduce((a, b)=>{
        if (b.length) return a.replace(/\/$/, "") + "/" + b.replace(/^\//, "");
        return a;
    }, "");
}
/**
 * A simple client-side router for single-page applications. It uses
 * express-style middleware and has a first-class support for Web Components and
 * lazy-loading. Works great in Polymer and non-Polymer apps.
 *
 * Use `new Router(outlet, options)` to create a new Router instance.
 *
 * * The `outlet` parameter is a reference to the DOM node to render
 *   the content into.
 *
 * * The `options` parameter is an optional object with options. The following
 *   keys are supported:
 *   * `baseUrl` — the initial value for [
 *     the `baseUrl` property
 *   ](#/classes/Router#property-baseUrl)
 *
 * The Router instance is automatically subscribed to navigation events
 * on `window`.
 *
 * See [Live Examples](#/classes/Router/demos/demo/index.html) for the detailed usage demo and code snippets.
 *
 * See also detailed API docs for the following methods, for the advanced usage:
 *
 * * [setOutlet](#/classes/Router#method-setOutlet) – should be used to configure the outlet.
 * * [setTriggers](#/classes/Router#method-setTriggers) – should be used to configure the navigation events.
 * * [setRoutes](#/classes/Router#method-setRoutes) – should be used to configure the routes.
 *
 * Only `setRoutes` has to be called manually, others are automatically invoked when creating a new instance.
 *
 * @extends Resolver
 * @demo demo/index.html
 * @summary JavaScript class that renders different DOM content depending on
 *    a given path. It can re-render when triggered or automatically on
 *    'popstate' and / or 'click' events.
 */ class $f9d9d110dea7aeee$export$55185c17a0fcbe46 extends $f9d9d110dea7aeee$export$8b4c839865b08288 {
    /**
   * Creates a new Router instance with a given outlet, and
   * automatically subscribes it to navigation events on the `window`.
   * Using a constructor argument or a setter for outlet is equivalent:
   *
   * ```
   * const router = new Router();
   * router.setOutlet(outlet);
   * ```
   * @param {?Node=} outlet
   * @param {?RouterOptions=} options
   */ constructor(outlet, options){
        const baseElement = document.head.querySelector("base");
        const baseHref = baseElement && baseElement.getAttribute("href");
        super([], Object.assign({
            // Default options
            baseUrl: baseHref && $f9d9d110dea7aeee$export$8b4c839865b08288.__createUrl(baseHref, document.URL).pathname.replace(/[^\/]*$/, "")
        }, options));
        this.resolveRoute = (context)=>this.__resolveRoute(context);
        const triggers = $f9d9d110dea7aeee$export$55185c17a0fcbe46.NavigationTrigger;
        $f9d9d110dea7aeee$export$55185c17a0fcbe46.setTriggers.apply($f9d9d110dea7aeee$export$55185c17a0fcbe46, Object.keys(triggers).map((key)=>triggers[key]));
        /**
     * The base URL for all routes in the router instance. By default,
     * if the base element exists in the `<head>`, vaadin-router
     * takes the `<base href>` attribute value, resolves against current `document.URL`
     * and gets the `pathname` from the result.
     *
     * @public
     * @type {string}
     */ this.baseUrl;
        /**
     * A promise that is settled after the current render cycle completes. If
     * there is no render cycle in progress the promise is immediately settled
     * with the last render cycle result.
     *
     * @public
     * @type {!Promise<!RouterLocation>}
     */ this.ready;
        this.ready = Promise.resolve(outlet);
        /**
     * Contains read-only information about the current router location:
     * pathname, active routes, parameters. See the
     * [Location type declaration](#/classes/RouterLocation)
     * for more details.
     *
     * @public
     * @type {!RouterLocation}
     */ this.location;
        this.location = $f9d9d110dea7aeee$var$createLocation({
            resolver: this
        });
        this.__lastStartedRenderId = 0;
        this.__navigationEventHandler = this.__onNavigationEvent.bind(this);
        this.setOutlet(outlet);
        this.subscribe();
        // Using WeakMap instead of WeakSet because WeakSet is not supported by IE11
        this.__createdByRouter = new WeakMap();
        this.__addedByRouter = new WeakMap();
    }
    __resolveRoute(context) {
        const route = context.route;
        let callbacks = Promise.resolve();
        if ($f9d9d110dea7aeee$var$isFunction(route.children)) callbacks = callbacks.then(()=>route.children($f9d9d110dea7aeee$var$copyContextWithoutNext(context))).then((children)=>{
            // The route.children() callback might have re-written the
            // route.children property instead of returning a value
            if (!$f9d9d110dea7aeee$var$isResultNotEmpty(children) && !$f9d9d110dea7aeee$var$isFunction(route.children)) children = route.children;
            $f9d9d110dea7aeee$var$processNewChildren(children, route);
        });
        const commands = {
            redirect: (path)=>$f9d9d110dea7aeee$var$createRedirect(context, path),
            component: (component)=>{
                const element = document.createElement(component);
                this.__createdByRouter.set(element, true);
                return element;
            }
        };
        return callbacks.then(()=>{
            if (this.__isLatestRender(context)) return $f9d9d110dea7aeee$var$runCallbackIfPossible(route.action, [
                context,
                commands
            ], route);
        }).then((result)=>{
            if ($f9d9d110dea7aeee$var$isResultNotEmpty(result)) {
                // Actions like `() => import('my-view.js')` are not expected to
                // end the resolution, despite the result is not empty. Checking
                // the result with a whitelist of values that end the resolution.
                if (result instanceof HTMLElement || result.redirect || result === $f9d9d110dea7aeee$var$notFoundResult) return result;
            }
            if ($f9d9d110dea7aeee$var$isString(route.redirect)) return commands.redirect(route.redirect);
            if (route.bundle) return $f9d9d110dea7aeee$var$loadBundle(route.bundle).then(()=>{}, ()=>{
                throw new Error($f9d9d110dea7aeee$var$log(`Bundle not found: ${route.bundle}. Check if the file name is correct`));
            });
        }).then((result)=>{
            if ($f9d9d110dea7aeee$var$isResultNotEmpty(result)) return result;
            if ($f9d9d110dea7aeee$var$isString(route.component)) return commands.component(route.component);
        });
    }
    /**
   * Sets the router outlet (the DOM node where the content for the current
   * route is inserted). Any content pre-existing in the router outlet is
   * removed at the end of each render pass.
   *
   * NOTE: this method is automatically invoked first time when creating a new Router instance.
   *
   * @param {?Node} outlet the DOM node where the content for the current route
   *     is inserted.
   */ setOutlet(outlet) {
        if (outlet) this.__ensureOutlet(outlet);
        this.__outlet = outlet;
    }
    /**
   * Returns the current router outlet. The initial value is `undefined`.
   *
   * @return {?Node} the current router outlet (or `undefined`)
   */ getOutlet() {
        return this.__outlet;
    }
    /**
   * Sets the routing config (replacing the existing one) and triggers a
   * navigation event so that the router outlet is refreshed according to the
   * current `window.location` and the new routing config.
   *
   * Each route object may have the following properties, listed here in the processing order:
   * * `path` – the route path (relative to the parent route if any) in the
   * [express.js syntax](https://expressjs.com/en/guide/routing.html#route-paths").
   *
   * * `children` – an array of nested routes or a function that provides this
   * array at the render time. The function can be synchronous or asynchronous:
   * in the latter case the render is delayed until the returned promise is
   * resolved. The `children` function is executed every time when this route is
   * being rendered. This allows for dynamic route structures (e.g. backend-defined),
   * but it might have a performance impact as well. In order to avoid calling
   * the function on subsequent renders, you can override the `children` property
   * of the route object and save the calculated array there
   * (via `context.route.children = [ route1, route2, ...];`).
   * Parent routes are fully resolved before resolving the children. Children
   * 'path' values are relative to the parent ones.
   *
   * * `action` – the action that is executed before the route is resolved.
   * The value for this property should be a function, accepting `context`
   * and `commands` parameters described below. If present, this function is
   * always invoked first, disregarding of the other properties' presence.
   * The action can return a result directly or within a `Promise`, which
   * resolves to the result. If the action result is an `HTMLElement` instance,
   * a `commands.component(name)` result, a `commands.redirect(path)` result,
   * or a `context.next()` result, the current route resolution is finished,
   * and other route config properties are ignored.
   * See also **Route Actions** section in [Live Examples](#/classes/Router/demos/demo/index.html).
   *
   * * `redirect` – other route's path to redirect to. Passes all route parameters to the redirect target.
   * The target route should also be defined.
   * See also **Redirects** section in [Live Examples](#/classes/Router/demos/demo/index.html).
   *
   * * `bundle` – string containing the path to `.js` or `.mjs` bundle to load before resolving the route,
   * or the object with "module" and "nomodule" keys referring to different bundles.
   * Each bundle is only loaded once. If "module" and "nomodule" are set, only one bundle is loaded,
   * depending on whether the browser supports ES modules or not.
   * The property is ignored when either an `action` returns the result or `redirect` property is present.
   * Any error, e.g. 404 while loading bundle will cause route resolution to throw.
   * See also **Code Splitting** section in [Live Examples](#/classes/Router/demos/demo/index.html).
   *
   * * `component` – the tag name of the Web Component to resolve the route to.
   * The property is ignored when either an `action` returns the result or `redirect` property is present.
   * If route contains the `component` property (or an action that return a component)
   * and its child route also contains the `component` property, child route's component
   * will be rendered as a light dom child of a parent component.
   *
   * * `name` – the string name of the route to use in the
   * [`router.urlForName(name, params)`](#/classes/Router#method-urlForName)
   * navigation helper method.
   *
   * For any route function (`action`, `children`) defined, the corresponding `route` object is available inside the callback
   * through the `this` reference. If you need to access it, make sure you define the callback as a non-arrow function
   * because arrow functions do not have their own `this` reference.
   *
   * `context` object that is passed to `action` function holds the following properties:
   * * `context.pathname` – string with the pathname being resolved
   *
   * * `context.search` – search query string
   *
   * * `context.hash` – hash string
   *
   * * `context.params` – object with route parameters
   *
   * * `context.route` – object that holds the route that is currently being rendered.
   *
   * * `context.next()` – function for asynchronously getting the next route
   * contents from the resolution chain (if any)
   *
   * `commands` object that is passed to `action` function has
   * the following methods:
   *
   * * `commands.redirect(path)` – function that creates a redirect data
   * for the path specified.
   *
   * * `commands.component(component)` – function that creates a new HTMLElement
   * with current context. Note: the component created by this function is reused if visiting the same path twice in row.
   *
   *
   * @param {!Array<!Route>|!Route} routes a single route or an array of those
   * @param {?boolean} skipRender configure the router but skip rendering the
   *     route corresponding to the current `window.location` values
   *
   * @return {!Promise<!Node>}
   */ setRoutes(routes, skipRender = false) {
        this.__previousContext = undefined;
        this.__urlForName = undefined;
        super.setRoutes(routes);
        if (!skipRender) this.__onNavigationEvent();
        return this.ready;
    }
    /**
   * Asynchronously resolves the given pathname and renders the resolved route
   * component into the router outlet. If no router outlet is set at the time of
   * calling this method, or at the time when the route resolution is completed,
   * a `TypeError` is thrown.
   *
   * Returns a promise that is fulfilled with the router outlet DOM Node after
   * the route component is created and inserted into the router outlet, or
   * rejected if no route matches the given path.
   *
   * If another render pass is started before the previous one is completed, the
   * result of the previous render pass is ignored.
   *
   * @param {!string|!{pathname: !string, search: ?string, hash: ?string}} pathnameOrContext
   *    the pathname to render or a context object with a `pathname` property,
   *    optional `search` and `hash` properties, and other properties
   *    to pass to the resolver.
   * @param {boolean=} shouldUpdateHistory
   *    update browser history with the rendered location
   * @return {!Promise<!Node>}
   */ render(pathnameOrContext, shouldUpdateHistory) {
        const renderId = ++this.__lastStartedRenderId;
        const context = Object.assign({
            search: "",
            hash: ""
        }, $f9d9d110dea7aeee$var$isString(pathnameOrContext) ? {
            pathname: pathnameOrContext
        } : pathnameOrContext, {
            __renderId: renderId
        });
        // Find the first route that resolves to a non-empty result
        this.ready = this.resolve(context)// Process the result of this.resolve() and handle all special commands:
        // (redirect / prevent / component). If the result is a 'component',
        // then go deeper and build the entire chain of nested components matching
        // the pathname. Also call all 'on before' callbacks along the way.
        .then((context)=>this.__fullyResolveChain(context)).then((context)=>{
            if (this.__isLatestRender(context)) {
                const previousContext = this.__previousContext;
                // Check if the render was prevented and make an early return in that case
                if (context === previousContext) {
                    // Replace the history with the previous context
                    // to make sure the URL stays the same.
                    this.__updateBrowserHistory(previousContext, true);
                    return this.location;
                }
                this.location = $f9d9d110dea7aeee$var$createLocation(context);
                if (shouldUpdateHistory) // Replace only if first render redirects, so that we don’t leave
                // the redirecting record in the history
                this.__updateBrowserHistory(context, renderId === 1);
                $f9d9d110dea7aeee$var$fireRouterEvent("location-changed", {
                    router: this,
                    location: this.location
                });
                // Skip detaching/re-attaching there are no render changes
                if (context.__skipAttach) {
                    this.__copyUnchangedElements(context, previousContext);
                    this.__previousContext = context;
                    return this.location;
                }
                this.__addAppearingContent(context, previousContext);
                const animationDone = this.__animateIfNeeded(context);
                this.__runOnAfterEnterCallbacks(context);
                this.__runOnAfterLeaveCallbacks(context, previousContext);
                return animationDone.then(()=>{
                    if (this.__isLatestRender(context)) {
                        // If there is another render pass started after this one,
                        // the 'disappearing content' would be removed when the other
                        // render pass calls `this.__addAppearingContent()`
                        this.__removeDisappearingContent();
                        this.__previousContext = context;
                        return this.location;
                    }
                });
            }
        }).catch((error)=>{
            if (renderId === this.__lastStartedRenderId) {
                if (shouldUpdateHistory) this.__updateBrowserHistory(context);
                $f9d9d110dea7aeee$var$removeDomNodes(this.__outlet && this.__outlet.children);
                this.location = $f9d9d110dea7aeee$var$createLocation(Object.assign(context, {
                    resolver: this
                }));
                $f9d9d110dea7aeee$var$fireRouterEvent("error", Object.assign({
                    router: this,
                    error: error
                }, context));
                throw error;
            }
        });
        return this.ready;
    }
    // `topOfTheChainContextBeforeRedirects` is a context coming from Resolver.resolve().
    // It would contain a 'redirect' route or the first 'component' route that
    // matched the pathname. There might be more child 'component' routes to be
    // resolved and added into the chain. This method would find and add them.
    // `contextBeforeRedirects` is the context containing such a child component
    // route. It's only necessary when this method is called recursively (otherwise
    // it's the same as the 'top of the chain' context).
    //
    // Apart from building the chain of child components, this method would also
    // handle 'redirect' routes, call 'onBefore' callbacks and handle 'prevent'
    // and 'redirect' callback results.
    __fullyResolveChain(topOfTheChainContextBeforeRedirects, contextBeforeRedirects = topOfTheChainContextBeforeRedirects) {
        return this.__findComponentContextAfterAllRedirects(contextBeforeRedirects)// `contextAfterRedirects` is always a context with an `HTMLElement` result
        // In other cases the promise gets rejected and .then() is not called
        .then((contextAfterRedirects)=>{
            const redirectsHappened = contextAfterRedirects !== contextBeforeRedirects;
            const topOfTheChainContextAfterRedirects = redirectsHappened ? contextAfterRedirects : topOfTheChainContextBeforeRedirects;
            const matchedPath = $f9d9d110dea7aeee$var$getPathnameForRouter($f9d9d110dea7aeee$var$getMatchedPath(contextAfterRedirects.chain), contextAfterRedirects.resolver);
            const isFound = matchedPath === contextAfterRedirects.pathname;
            // Recursive method to try matching more child and sibling routes
            const findNextContextIfAny = (context, parent = context.route, prevResult)=>{
                return context.next(undefined, parent, prevResult).then((nextContext)=>{
                    if (nextContext === null || nextContext === $f9d9d110dea7aeee$var$notFoundResult) {
                        // Next context is not found in children, ...
                        if (isFound) // ...but original context is already fully matching - use it
                        return context;
                        else if (parent.parent !== null) // ...and there is no full match yet - step up to check siblings
                        return findNextContextIfAny(context, parent.parent, nextContext);
                        else return nextContext;
                    }
                    return nextContext;
                });
            };
            return findNextContextIfAny(contextAfterRedirects).then((nextContext)=>{
                if (nextContext === null || nextContext === $f9d9d110dea7aeee$var$notFoundResult) throw $f9d9d110dea7aeee$var$getNotFoundError(topOfTheChainContextAfterRedirects);
                return nextContext && nextContext !== $f9d9d110dea7aeee$var$notFoundResult && nextContext !== contextAfterRedirects ? this.__fullyResolveChain(topOfTheChainContextAfterRedirects, nextContext) : this.__amendWithOnBeforeCallbacks(contextAfterRedirects);
            });
        });
    }
    __findComponentContextAfterAllRedirects(context) {
        const result = context.result;
        if (result instanceof HTMLElement) {
            $f9d9d110dea7aeee$var$renderElement(context, result);
            return Promise.resolve(context);
        } else if (result.redirect) return this.__redirect(result.redirect, context.__redirectCount, context.__renderId).then((context)=>this.__findComponentContextAfterAllRedirects(context));
        else if (result instanceof Error) return Promise.reject(result);
        else return Promise.reject(new Error($f9d9d110dea7aeee$var$log(`Invalid route resolution result for path "${context.pathname}". ` + `Expected redirect object or HTML element, but got: "${$f9d9d110dea7aeee$var$logValue(result)}". ` + `Double check the action return value for the route.`)));
    }
    __amendWithOnBeforeCallbacks(contextWithFullChain) {
        return this.__runOnBeforeCallbacks(contextWithFullChain).then((amendedContext)=>{
            if (amendedContext === this.__previousContext || amendedContext === contextWithFullChain) return amendedContext;
            return this.__fullyResolveChain(amendedContext);
        });
    }
    __runOnBeforeCallbacks(newContext) {
        const previousContext = this.__previousContext || {};
        const previousChain = previousContext.chain || [];
        const newChain = newContext.chain;
        let callbacks = Promise.resolve();
        const prevent = ()=>({
                cancel: true
            });
        const redirect = (pathname)=>$f9d9d110dea7aeee$var$createRedirect(newContext, pathname);
        newContext.__divergedChainIndex = 0;
        newContext.__skipAttach = false;
        if (previousChain.length) {
            for(let i = 0; i < Math.min(previousChain.length, newChain.length); i = ++newContext.__divergedChainIndex){
                if (previousChain[i].route !== newChain[i].route || previousChain[i].path !== newChain[i].path && previousChain[i].element !== newChain[i].element || !this.__isReusableElement(previousChain[i].element, newChain[i].element)) break;
            }
            // Skip re-attaching and notifications if element and chain do not change
            newContext.__skipAttach = // Same route chain
            newChain.length === previousChain.length && newContext.__divergedChainIndex == newChain.length && // Same element
            this.__isReusableElement(newContext.result, previousContext.result);
            if (newContext.__skipAttach) {
                // execute onBeforeLeave for changed segment element when skipping attach
                for(let i = newChain.length - 1; i >= 0; i--)callbacks = this.__runOnBeforeLeaveCallbacks(callbacks, newContext, {
                    prevent: prevent
                }, previousChain[i]);
                // execute onBeforeEnter for changed segment element when skipping attach
                for(let i = 0; i < newChain.length; i++){
                    callbacks = this.__runOnBeforeEnterCallbacks(callbacks, newContext, {
                        prevent: prevent,
                        redirect: redirect
                    }, newChain[i]);
                    previousChain[i].element.location = $f9d9d110dea7aeee$var$createLocation(newContext, previousChain[i].route);
                }
            } else // execute onBeforeLeave when NOT skipping attach
            for(let i = previousChain.length - 1; i >= newContext.__divergedChainIndex; i--)callbacks = this.__runOnBeforeLeaveCallbacks(callbacks, newContext, {
                prevent: prevent
            }, previousChain[i]);
        }
        // execute onBeforeEnter when NOT skipping attach
        if (!newContext.__skipAttach) for(let i = 0; i < newChain.length; i++){
            if (i < newContext.__divergedChainIndex) {
                if (i < previousChain.length && previousChain[i].element) previousChain[i].element.location = $f9d9d110dea7aeee$var$createLocation(newContext, previousChain[i].route);
            } else {
                callbacks = this.__runOnBeforeEnterCallbacks(callbacks, newContext, {
                    prevent: prevent,
                    redirect: redirect
                }, newChain[i]);
                if (newChain[i].element) newChain[i].element.location = $f9d9d110dea7aeee$var$createLocation(newContext, newChain[i].route);
            }
        }
        return callbacks.then((amendmentResult)=>{
            if (amendmentResult) {
                if (amendmentResult.cancel) {
                    this.__previousContext.__renderId = newContext.__renderId;
                    return this.__previousContext;
                }
                if (amendmentResult.redirect) return this.__redirect(amendmentResult.redirect, newContext.__redirectCount, newContext.__renderId);
            }
            return newContext;
        });
    }
    __runOnBeforeLeaveCallbacks(callbacks, newContext, commands, chainElement) {
        const location = $f9d9d110dea7aeee$var$createLocation(newContext);
        return callbacks.then((result)=>{
            if (this.__isLatestRender(newContext)) {
                const afterLeaveFunction = $f9d9d110dea7aeee$var$amend("onBeforeLeave", [
                    location,
                    commands,
                    this
                ], chainElement.element);
                return afterLeaveFunction(result);
            }
        }).then((result)=>{
            if (!(result || {}).redirect) return result;
        });
    }
    __runOnBeforeEnterCallbacks(callbacks, newContext, commands, chainElement) {
        const location = $f9d9d110dea7aeee$var$createLocation(newContext, chainElement.route);
        return callbacks.then((result)=>{
            if (this.__isLatestRender(newContext)) {
                const beforeEnterFunction = $f9d9d110dea7aeee$var$amend("onBeforeEnter", [
                    location,
                    commands,
                    this
                ], chainElement.element);
                return beforeEnterFunction(result);
            }
        });
    }
    __isReusableElement(element, otherElement) {
        if (element && otherElement) return this.__createdByRouter.get(element) && this.__createdByRouter.get(otherElement) ? element.localName === otherElement.localName : element === otherElement;
        return false;
    }
    __isLatestRender(context) {
        return context.__renderId === this.__lastStartedRenderId;
    }
    __redirect(redirectData, counter, renderId) {
        if (counter > $f9d9d110dea7aeee$var$MAX_REDIRECT_COUNT) throw new Error($f9d9d110dea7aeee$var$log(`Too many redirects when rendering ${redirectData.from}`));
        return this.resolve({
            pathname: this.urlForPath(redirectData.pathname, redirectData.params),
            redirectFrom: redirectData.from,
            __redirectCount: (counter || 0) + 1,
            __renderId: renderId
        });
    }
    __ensureOutlet(outlet = this.__outlet) {
        if (!(outlet instanceof Node)) throw new TypeError($f9d9d110dea7aeee$var$log(`Expected router outlet to be a valid DOM Node (but got ${outlet})`));
    }
    __updateBrowserHistory({ pathname: pathname, search: search = "", hash: hash = "" }, replace) {
        if (window.location.pathname !== pathname || window.location.search !== search || window.location.hash !== hash) {
            const changeState = replace ? "replaceState" : "pushState";
            window.history[changeState](null, document.title, pathname + search + hash);
            window.dispatchEvent(new PopStateEvent("popstate", {
                state: "vaadin-router-ignore"
            }));
        }
    }
    __copyUnchangedElements(context, previousContext) {
        // Find the deepest common parent between the last and the new component
        // chains. Update references for the unchanged elements in the new chain
        let deepestCommonParent = this.__outlet;
        for(let i = 0; i < context.__divergedChainIndex; i++){
            const unchangedElement = previousContext && previousContext.chain[i].element;
            if (unchangedElement) {
                if (unchangedElement.parentNode === deepestCommonParent) {
                    context.chain[i].element = unchangedElement;
                    deepestCommonParent = unchangedElement;
                } else break;
            }
        }
        return deepestCommonParent;
    }
    __addAppearingContent(context, previousContext) {
        this.__ensureOutlet();
        // If the previous 'entering' animation has not completed yet,
        // stop it and remove that content from the DOM before adding new one.
        this.__removeAppearingContent();
        // Copy reusable elements from the previousContext to current
        const deepestCommonParent = this.__copyUnchangedElements(context, previousContext);
        // Keep two lists of DOM elements:
        //  - those that should be removed once the transition animation is over
        //  - and those that should remain
        this.__appearingContent = [];
        this.__disappearingContent = Array.from(deepestCommonParent.children).filter(// Only remove layout content that was added by router
        (e)=>this.__addedByRouter.get(e) && // Do not remove the result element to avoid flickering
            e !== context.result);
        // Add new elements (starting after the deepest common parent) to the DOM.
        // That way only the components that are actually different between the two
        // locations are added to the DOM (and those that are common remain in the
        // DOM without first removing and then adding them again).
        let parentElement = deepestCommonParent;
        for(let i = context.__divergedChainIndex; i < context.chain.length; i++){
            const elementToAdd = context.chain[i].element;
            if (elementToAdd) {
                parentElement.appendChild(elementToAdd);
                this.__addedByRouter.set(elementToAdd, true);
                if (parentElement === deepestCommonParent) this.__appearingContent.push(elementToAdd);
                parentElement = elementToAdd;
            }
        }
    }
    __removeDisappearingContent() {
        if (this.__disappearingContent) $f9d9d110dea7aeee$var$removeDomNodes(this.__disappearingContent);
        this.__disappearingContent = null;
        this.__appearingContent = null;
    }
    __removeAppearingContent() {
        if (this.__disappearingContent && this.__appearingContent) {
            $f9d9d110dea7aeee$var$removeDomNodes(this.__appearingContent);
            this.__disappearingContent = null;
            this.__appearingContent = null;
        }
    }
    __runOnAfterLeaveCallbacks(currentContext, targetContext) {
        if (!targetContext) return;
        // REVERSE iteration: from Z to A
        for(let i = targetContext.chain.length - 1; i >= currentContext.__divergedChainIndex; i--){
            if (!this.__isLatestRender(currentContext)) break;
            const currentComponent = targetContext.chain[i].element;
            if (!currentComponent) continue;
            try {
                const location = $f9d9d110dea7aeee$var$createLocation(currentContext);
                $f9d9d110dea7aeee$var$runCallbackIfPossible(currentComponent.onAfterLeave, [
                    location,
                    {},
                    targetContext.resolver
                ], currentComponent);
            } finally{
                if (this.__disappearingContent.indexOf(currentComponent) > -1) $f9d9d110dea7aeee$var$removeDomNodes(currentComponent.children);
            }
        }
    }
    __runOnAfterEnterCallbacks(currentContext) {
        // forward iteration: from A to Z
        for(let i = currentContext.__divergedChainIndex; i < currentContext.chain.length; i++){
            if (!this.__isLatestRender(currentContext)) break;
            const currentComponent = currentContext.chain[i].element || {};
            const location = $f9d9d110dea7aeee$var$createLocation(currentContext, currentContext.chain[i].route);
            $f9d9d110dea7aeee$var$runCallbackIfPossible(currentComponent.onAfterEnter, [
                location,
                {},
                currentContext.resolver
            ], currentComponent);
        }
    }
    __animateIfNeeded(context) {
        const from = (this.__disappearingContent || [])[0];
        const to = (this.__appearingContent || [])[0];
        const promises = [];
        const chain = context.chain;
        let config;
        for(let i = chain.length; i > 0; i--)if (chain[i - 1].route.animate) {
            config = chain[i - 1].route.animate;
            break;
        }
        if (from && to && config) {
            const leave = $f9d9d110dea7aeee$var$isObject(config) && config.leave || "leaving";
            const enter = $f9d9d110dea7aeee$var$isObject(config) && config.enter || "entering";
            promises.push($f9d9d110dea7aeee$var$animate(from, leave));
            promises.push($f9d9d110dea7aeee$var$animate(to, enter));
        }
        return Promise.all(promises).then(()=>context);
    }
    /**
   * Subscribes this instance to navigation events on the `window`.
   *
   * NOTE: beware of resource leaks. For as long as a router instance is
   * subscribed to navigation events, it won't be garbage collected.
   */ subscribe() {
        window.addEventListener("vaadin-router-go", this.__navigationEventHandler);
    }
    /**
   * Removes the subscription to navigation events created in the `subscribe()`
   * method.
   */ unsubscribe() {
        window.removeEventListener("vaadin-router-go", this.__navigationEventHandler);
    }
    __onNavigationEvent(event) {
        const { pathname: pathname, search: search, hash: hash } = event ? event.detail : window.location;
        if ($f9d9d110dea7aeee$var$isString(this.__normalizePathname(pathname))) {
            if (event && event.preventDefault) event.preventDefault();
            this.render({
                pathname: pathname,
                search: search,
                hash: hash
            }, true);
        }
    }
    /**
   * Configures what triggers Router navigation events:
   *  - `POPSTATE`: popstate events on the current `window`
   *  - `CLICK`: click events on `<a>` links leading to the current page
   *
   * This method is invoked with the pre-configured values when creating a new Router instance.
   * By default, both `POPSTATE` and `CLICK` are enabled. This setup is expected to cover most of the use cases.
   *
   * See the `router-config.js` for the default navigation triggers config. Based on it, you can
   * create the own one and only import the triggers you need, instead of pulling in all the code,
   * e.g. if you want to handle `click` differently.
   *
   * See also **Navigation Triggers** section in [Live Examples](#/classes/Router/demos/demo/index.html).
   *
   * @param {...NavigationTrigger} triggers
   */ static setTriggers(...triggers) {
        $f9d9d110dea7aeee$var$setNavigationTriggers(triggers);
    }
    /**
   * Generates a URL for the route with the given name, optionally performing
   * substitution of parameters.
   *
   * The route is searched in all the Router instances subscribed to
   * navigation events.
   *
   * **Note:** For child route names, only array children are considered.
   * It is not possible to generate URLs using a name for routes set with
   * a children function.
   *
   * @function urlForName
   * @param {!string} name the route name or the route’s `component` name.
   * @param {Params=} params Optional object with route path parameters.
   * Named parameters are passed by name (`params[name] = value`), unnamed
   * parameters are passed by index (`params[index] = value`).
   *
   * @return {string}
   */ urlForName(name, params) {
        if (!this.__urlForName) this.__urlForName = $f9d9d110dea7aeee$var$generateUrls(this);
        return $f9d9d110dea7aeee$var$getPathnameForRouter(this.__urlForName(name, params), this);
    }
    /**
   * Generates a URL for the given route path, optionally performing
   * substitution of parameters.
   *
   * @param {!string} path string route path declared in [express.js syntax](https://expressjs.com/en/guide/routing.html#route-paths").
   * @param {Params=} params Optional object with route path parameters.
   * Named parameters are passed by name (`params[name] = value`), unnamed
   * parameters are passed by index (`params[index] = value`).
   *
   * @return {string}
   */ urlForPath(path, params) {
        return $f9d9d110dea7aeee$var$getPathnameForRouter($f9d9d110dea7aeee$export$55185c17a0fcbe46.pathToRegexp.compile(path)(params), this);
    }
    /**
   * Triggers navigation to a new path. Returns a boolean without waiting until
   * the navigation is complete. Returns `true` if at least one `Router`
   * has handled the navigation (was subscribed and had `baseUrl` matching
   * the `path` argument), otherwise returns `false`.
   *
   * @param {!string|!{pathname: !string, search: (string|undefined), hash: (string|undefined)}} path
   *   a new in-app path string, or an URL-like object with `pathname`
   *   string property, and optional `search` and `hash` string properties.
   * @return {boolean}
   */ static go(path) {
        const { pathname: pathname, search: search, hash: hash } = $f9d9d110dea7aeee$var$isString(path) ? this.__createUrl(path, "http://a") // some base to omit origin
         : path;
        return $f9d9d110dea7aeee$var$fireRouterEvent("go", {
            pathname: pathname,
            search: search,
            hash: hash
        });
    }
}
const $f9d9d110dea7aeee$var$DEV_MODE_CODE_REGEXP = /\/\*[\*!]\s+vaadin-dev-mode:start([\s\S]*)vaadin-dev-mode:end\s+\*\*\//i;
const $f9d9d110dea7aeee$var$FlowClients = window.Vaadin && window.Vaadin.Flow && window.Vaadin.Flow.clients;
function $f9d9d110dea7aeee$var$isMinified() {
    function test() {
        /** vaadin-dev-mode:start
    return false;
    vaadin-dev-mode:end **/ return true;
    }
    return $f9d9d110dea7aeee$var$uncommentAndRun(test);
}
function $f9d9d110dea7aeee$var$isDevelopmentMode() {
    try {
        if ($f9d9d110dea7aeee$var$isForcedDevelopmentMode()) return true;
        if (!$f9d9d110dea7aeee$var$isLocalhost()) return false;
        if ($f9d9d110dea7aeee$var$FlowClients) return !$f9d9d110dea7aeee$var$isFlowProductionMode();
        return !$f9d9d110dea7aeee$var$isMinified();
    } catch (e) {
        // Some error in this code, assume production so no further actions will be taken
        return false;
    }
}
function $f9d9d110dea7aeee$var$isForcedDevelopmentMode() {
    return localStorage.getItem("vaadin.developmentmode.force");
}
function $f9d9d110dea7aeee$var$isLocalhost() {
    return [
        "localhost",
        "127.0.0.1"
    ].indexOf(window.location.hostname) >= 0;
}
function $f9d9d110dea7aeee$var$isFlowProductionMode() {
    if ($f9d9d110dea7aeee$var$FlowClients) {
        const productionModeApps = Object.keys($f9d9d110dea7aeee$var$FlowClients).map((key)=>$f9d9d110dea7aeee$var$FlowClients[key]).filter((client)=>client.productionMode);
        if (productionModeApps.length > 0) return true;
    }
    return false;
}
function $f9d9d110dea7aeee$var$uncommentAndRun(callback, args) {
    if (typeof callback !== "function") return;
    const match = $f9d9d110dea7aeee$var$DEV_MODE_CODE_REGEXP.exec(callback.toString());
    if (match) try {
        // requires CSP: script-src 'unsafe-eval'
        callback = new Function(match[1]);
    } catch (e) {
        // eat the exception
        console.log("vaadin-development-mode-detector: uncommentAndRun() failed", e);
    }
    return callback(args);
}
// A guard against polymer-modulizer removing the window.Vaadin
// initialization above.
window["Vaadin"] = window["Vaadin"] || {};
/**
 * Inspects the source code of the given `callback` function for
 * specially-marked _commented_ code. If such commented code is found in the
 * callback source, uncomments and runs that code instead of the callback
 * itself. Otherwise runs the callback as is.
 *
 * The optional arguments are passed into the callback / uncommented code,
 * the result is returned.
 *
 * See the `isMinified()` function source code in this file for an example.
 *
 */ const $f9d9d110dea7aeee$var$runIfDevelopmentMode = function(callback, args) {
    if (window.Vaadin.developmentMode) return $f9d9d110dea7aeee$var$uncommentAndRun(callback, args);
};
if (window.Vaadin.developmentMode === undefined) window.Vaadin.developmentMode = $f9d9d110dea7aeee$var$isDevelopmentMode();
/* This file is autogenerated from src/vaadin-usage-statistics.tpl.html */ function $f9d9d110dea7aeee$var$maybeGatherAndSendStats() {
/** vaadin-dev-mode:start
  (function () {
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var getPolymerVersion = function getPolymerVersion() {
  return window.Polymer && window.Polymer.version;
};

var StatisticsGatherer = function () {
  function StatisticsGatherer(logger) {
    classCallCheck(this, StatisticsGatherer);

    this.now = new Date().getTime();
    this.logger = logger;
  }

  createClass(StatisticsGatherer, [{
    key: 'frameworkVersionDetectors',
    value: function frameworkVersionDetectors() {
      return {
        'Flow': function Flow() {
          if (window.Vaadin && window.Vaadin.Flow && window.Vaadin.Flow.clients) {
            var flowVersions = Object.keys(window.Vaadin.Flow.clients).map(function (key) {
              return window.Vaadin.Flow.clients[key];
            }).filter(function (client) {
              return client.getVersionInfo;
            }).map(function (client) {
              return client.getVersionInfo().flow;
            });
            if (flowVersions.length > 0) {
              return flowVersions[0];
            }
          }
        },
        'Vaadin Framework': function VaadinFramework() {
          if (window.vaadin && window.vaadin.clients) {
            var frameworkVersions = Object.values(window.vaadin.clients).filter(function (client) {
              return client.getVersionInfo;
            }).map(function (client) {
              return client.getVersionInfo().vaadinVersion;
            });
            if (frameworkVersions.length > 0) {
              return frameworkVersions[0];
            }
          }
        },
        'AngularJs': function AngularJs() {
          if (window.angular && window.angular.version && window.angular.version) {
            return window.angular.version.full;
          }
        },
        'Angular': function Angular() {
          if (window.ng) {
            var tags = document.querySelectorAll("[ng-version]");
            if (tags.length > 0) {
              return tags[0].getAttribute("ng-version");
            }
            return "Unknown";
          }
        },
        'Backbone.js': function BackboneJs() {
          if (window.Backbone) {
            return window.Backbone.VERSION;
          }
        },
        'React': function React() {
          var reactSelector = '[data-reactroot], [data-reactid]';
          if (!!document.querySelector(reactSelector)) {
            // React does not publish the version by default
            return "unknown";
          }
        },
        'Ember': function Ember() {
          if (window.Em && window.Em.VERSION) {
            return window.Em.VERSION;
          } else if (window.Ember && window.Ember.VERSION) {
            return window.Ember.VERSION;
          }
        },
        'jQuery': function (_jQuery) {
          function jQuery() {
            return _jQuery.apply(this, arguments);
          }

          jQuery.toString = function () {
            return _jQuery.toString();
          };

          return jQuery;
        }(function () {
          if (typeof jQuery === 'function' && jQuery.prototype.jquery !== undefined) {
            return jQuery.prototype.jquery;
          }
        }),
        'Polymer': function Polymer() {
          var version = getPolymerVersion();
          if (version) {
            return version;
          }
        },
        'LitElement': function LitElement() {
          var version = window.litElementVersions && window.litElementVersions[0];
          if (version) {
            return version;
          }
        },
        'LitHtml': function LitHtml() {
          var version = window.litHtmlVersions && window.litHtmlVersions[0];
          if (version) {
            return version;
          }
        },
        'Vue.js': function VueJs() {
          if (window.Vue) {
            return window.Vue.version;
          }
        }
      };
    }
  }, {
    key: 'getUsedVaadinElements',
    value: function getUsedVaadinElements(elements) {
      var version = getPolymerVersion();
      var elementClasses = void 0;
      // NOTE: In case you edit the code here, YOU MUST UPDATE any statistics reporting code in Flow.
      // Check all locations calling the method getEntries() in
      // https://github.com/vaadin/flow/blob/master/flow-server/src/main/java/com/vaadin/flow/internal/UsageStatistics.java#L106
      // Currently it is only used by BootstrapHandler.
      if (version && version.indexOf('2') === 0) {
        // Polymer 2: components classes are stored in window.Vaadin
        elementClasses = Object.keys(window.Vaadin).map(function (c) {
          return window.Vaadin[c];
        }).filter(function (c) {
          return c.is;
        });
      } else {
        // Polymer 3: components classes are stored in window.Vaadin.registrations
        elementClasses = window.Vaadin.registrations || [];
      }
      elementClasses.forEach(function (klass) {
        var version = klass.version ? klass.version : "0.0.0";
        elements[klass.is] = { version: version };
      });
    }
  }, {
    key: 'getUsedVaadinThemes',
    value: function getUsedVaadinThemes(themes) {
      ['Lumo', 'Material'].forEach(function (themeName) {
        var theme;
        var version = getPolymerVersion();
        if (version && version.indexOf('2') === 0) {
          // Polymer 2: themes are stored in window.Vaadin
          theme = window.Vaadin[themeName];
        } else {
          // Polymer 3: themes are stored in custom element registry
          theme = customElements.get('vaadin-' + themeName.toLowerCase() + '-styles');
        }
        if (theme && theme.version) {
          themes[themeName] = { version: theme.version };
        }
      });
    }
  }, {
    key: 'getFrameworks',
    value: function getFrameworks(frameworks) {
      var detectors = this.frameworkVersionDetectors();
      Object.keys(detectors).forEach(function (framework) {
        var detector = detectors[framework];
        try {
          var version = detector();
          if (version) {
            frameworks[framework] = { version: version };
          }
        } catch (e) {}
      });
    }
  }, {
    key: 'gather',
    value: function gather(storage) {
      var storedStats = storage.read();
      var gatheredStats = {};
      var types = ["elements", "frameworks", "themes"];

      types.forEach(function (type) {
        gatheredStats[type] = {};
        if (!storedStats[type]) {
          storedStats[type] = {};
        }
      });

      var previousStats = JSON.stringify(storedStats);

      this.getUsedVaadinElements(gatheredStats.elements);
      this.getFrameworks(gatheredStats.frameworks);
      this.getUsedVaadinThemes(gatheredStats.themes);

      var now = this.now;
      types.forEach(function (type) {
        var keys = Object.keys(gatheredStats[type]);
        keys.forEach(function (key) {
          if (!storedStats[type][key] || _typeof(storedStats[type][key]) != _typeof({})) {
            storedStats[type][key] = { firstUsed: now };
          }
          // Discards any previously logged version number
          storedStats[type][key].version = gatheredStats[type][key].version;
          storedStats[type][key].lastUsed = now;
        });
      });

      var newStats = JSON.stringify(storedStats);
      storage.write(newStats);
      if (newStats != previousStats && Object.keys(storedStats).length > 0) {
        this.logger.debug("New stats: " + newStats);
      }
    }
  }]);
  return StatisticsGatherer;
}();

var StatisticsStorage = function () {
  function StatisticsStorage(key) {
    classCallCheck(this, StatisticsStorage);

    this.key = key;
  }

  createClass(StatisticsStorage, [{
    key: 'read',
    value: function read() {
      var localStorageStatsString = localStorage.getItem(this.key);
      try {
        return JSON.parse(localStorageStatsString ? localStorageStatsString : '{}');
      } catch (e) {
        return {};
      }
    }
  }, {
    key: 'write',
    value: function write(data) {
      localStorage.setItem(this.key, data);
    }
  }, {
    key: 'clear',
    value: function clear() {
      localStorage.removeItem(this.key);
    }
  }, {
    key: 'isEmpty',
    value: function isEmpty() {
      var storedStats = this.read();
      var empty = true;
      Object.keys(storedStats).forEach(function (key) {
        if (Object.keys(storedStats[key]).length > 0) {
          empty = false;
        }
      });

      return empty;
    }
  }]);
  return StatisticsStorage;
}();

var StatisticsSender = function () {
  function StatisticsSender(url, logger) {
    classCallCheck(this, StatisticsSender);

    this.url = url;
    this.logger = logger;
  }

  createClass(StatisticsSender, [{
    key: 'send',
    value: function send(data, errorHandler) {
      var logger = this.logger;

      if (navigator.onLine === false) {
        logger.debug("Offline, can't send");
        errorHandler();
        return;
      }
      logger.debug("Sending data to " + this.url);

      var req = new XMLHttpRequest();
      req.withCredentials = true;
      req.addEventListener("load", function () {
        // Stats sent, nothing more to do
        logger.debug("Response: " + req.responseText);
      });
      req.addEventListener("error", function () {
        logger.debug("Send failed");
        errorHandler();
      });
      req.addEventListener("abort", function () {
        logger.debug("Send aborted");
        errorHandler();
      });
      req.open("POST", this.url);
      req.setRequestHeader("Content-Type", "application/json");
      req.send(data);
    }
  }]);
  return StatisticsSender;
}();

var StatisticsLogger = function () {
  function StatisticsLogger(id) {
    classCallCheck(this, StatisticsLogger);

    this.id = id;
  }

  createClass(StatisticsLogger, [{
    key: '_isDebug',
    value: function _isDebug() {
      return localStorage.getItem("vaadin." + this.id + ".debug");
    }
  }, {
    key: 'debug',
    value: function debug(msg) {
      if (this._isDebug()) {
        console.info(this.id + ": " + msg);
      }
    }
  }]);
  return StatisticsLogger;
}();

var UsageStatistics = function () {
  function UsageStatistics() {
    classCallCheck(this, UsageStatistics);

    this.now = new Date();
    this.timeNow = this.now.getTime();
    this.gatherDelay = 10; // Delay between loading this file and gathering stats
    this.initialDelay = 24 * 60 * 60;

    this.logger = new StatisticsLogger("statistics");
    this.storage = new StatisticsStorage("vaadin.statistics.basket");
    this.gatherer = new StatisticsGatherer(this.logger);
    this.sender = new StatisticsSender("https://tools.vaadin.com/usage-stats/submit", this.logger);
  }

  createClass(UsageStatistics, [{
    key: 'maybeGatherAndSend',
    value: function maybeGatherAndSend() {
      var _this = this;

      if (localStorage.getItem(UsageStatistics.optOutKey)) {
        return;
      }
      this.gatherer.gather(this.storage);
      setTimeout(function () {
        _this.maybeSend();
      }, this.gatherDelay * 1000);
    }
  }, {
    key: 'lottery',
    value: function lottery() {
      return true;
    }
  }, {
    key: 'currentMonth',
    value: function currentMonth() {
      return this.now.getYear() * 12 + this.now.getMonth();
    }
  }, {
    key: 'maybeSend',
    value: function maybeSend() {
      var firstUse = Number(localStorage.getItem(UsageStatistics.firstUseKey));
      var monthProcessed = Number(localStorage.getItem(UsageStatistics.monthProcessedKey));

      if (!firstUse) {
        // Use a grace period to avoid interfering with tests, incognito mode etc
        firstUse = this.timeNow;
        localStorage.setItem(UsageStatistics.firstUseKey, firstUse);
      }

      if (this.timeNow < firstUse + this.initialDelay * 1000) {
        this.logger.debug("No statistics will be sent until the initial delay of " + this.initialDelay + "s has passed");
        return;
      }
      if (this.currentMonth() <= monthProcessed) {
        this.logger.debug("This month has already been processed");
        return;
      }
      localStorage.setItem(UsageStatistics.monthProcessedKey, this.currentMonth());
      // Use random sampling
      if (this.lottery()) {
        this.logger.debug("Congratulations, we have a winner!");
      } else {
        this.logger.debug("Sorry, no stats from you this time");
        return;
      }

      this.send();
    }
  }, {
    key: 'send',
    value: function send() {
      // Ensure we have the latest data
      this.gatherer.gather(this.storage);

      // Read, send and clean up
      var data = this.storage.read();
      data["firstUse"] = Number(localStorage.getItem(UsageStatistics.firstUseKey));
      data["usageStatisticsVersion"] = UsageStatistics.version;
      var info = 'This request contains usage statistics gathered from the application running in development mode. \n\nStatistics gathering is automatically disabled and excluded from production builds.\n\nFor details and to opt-out, see https://github.com/vaadin/vaadin-usage-statistics.\n\n\n\n';
      var self = this;
      this.sender.send(info + JSON.stringify(data), function () {
        // Revert the 'month processed' flag
        localStorage.setItem(UsageStatistics.monthProcessedKey, self.currentMonth() - 1);
      });
    }
  }], [{
    key: 'version',
    get: function get$1() {
      return '2.1.2';
    }
  }, {
    key: 'firstUseKey',
    get: function get$1() {
      return 'vaadin.statistics.firstuse';
    }
  }, {
    key: 'monthProcessedKey',
    get: function get$1() {
      return 'vaadin.statistics.monthProcessed';
    }
  }, {
    key: 'optOutKey',
    get: function get$1() {
      return 'vaadin.statistics.optout';
    }
  }]);
  return UsageStatistics;
}();

try {
  window.Vaadin = window.Vaadin || {};
  window.Vaadin.usageStatsChecker = window.Vaadin.usageStatsChecker || new UsageStatistics();
  window.Vaadin.usageStatsChecker.maybeGatherAndSend();
} catch (e) {
  // Intentionally ignored as this is not a problem in the app being developed
}

}());

  vaadin-dev-mode:end **/ }
const $f9d9d110dea7aeee$var$usageStatistics = function() {
    if (typeof $f9d9d110dea7aeee$var$runIfDevelopmentMode === "function") return $f9d9d110dea7aeee$var$runIfDevelopmentMode($f9d9d110dea7aeee$var$maybeGatherAndSendStats);
};
window.Vaadin = window.Vaadin || {};
window.Vaadin.registrations = window.Vaadin.registrations || [];
window.Vaadin.registrations.push({
    is: "@vaadin/router",
    version: "1.7.4"
});
$f9d9d110dea7aeee$var$usageStatistics();
$f9d9d110dea7aeee$export$55185c17a0fcbe46.NavigationTrigger = {
    POPSTATE: $f9d9d110dea7aeee$var$POPSTATE,
    CLICK: $f9d9d110dea7aeee$var$CLICK
};



var $800sp = parcelRequire("800sp");

var $4OBpG = parcelRequire("4OBpG");
"use strict";
var $59575bf95b04eab7$var$_dec, $59575bf95b04eab7$var$_dec2, $59575bf95b04eab7$var$_class, $59575bf95b04eab7$var$_class2, $59575bf95b04eab7$var$_descriptor, $59575bf95b04eab7$var$_HelloWorldView;
function $59575bf95b04eab7$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $59575bf95b04eab7$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer && (Object.defineProperty(i, e, a), a = null), a;
}
function $59575bf95b04eab7$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $59575bf95b04eab7$export$fd7e17f091dbb959 = ($59575bf95b04eab7$var$_dec = (0, $4OBpG.customElement)("hello-world-view"), $59575bf95b04eab7$var$_dec2 = (0, $4OBpG.property)(), $59575bf95b04eab7$var$_dec($59575bf95b04eab7$var$_class = ($59575bf95b04eab7$var$_class2 = ($59575bf95b04eab7$var$_HelloWorldView = class HelloWorldView extends (0, $800sp.LitElement) {
    constructor(...args){
        super(...args);
        $59575bf95b04eab7$var$_initializerDefineProperty(this, "message", $59575bf95b04eab7$var$_descriptor, this);
    }
    render() {
        return (0, $800sp.html)`<p>${this.message}</p>`;
    }
}, $59575bf95b04eab7$var$_HelloWorldView.styles = (0, $800sp.css)`
    :host {
      display: block;
      padding: 16px;
      background-color: red;
    }
  `, $59575bf95b04eab7$var$_HelloWorldView), $59575bf95b04eab7$var$_descriptor = $59575bf95b04eab7$var$_applyDecoratedDescriptor($59575bf95b04eab7$var$_class2.prototype, "message", [
    $59575bf95b04eab7$var$_dec2
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "Hello World View";
    }
}), $59575bf95b04eab7$var$_class2)) || $59575bf95b04eab7$var$_class);




const $2e71e547e293311f$export$d0079916fe6800ac = [
    {
        path: "",
        component: "hello-world-view"
    },
    {
        path: "hello",
        component: "hello-world-view"
    },
    {
        path: "about",
        component: "about-view"
    }
];
const $2e71e547e293311f$export$66b32f6f30eb4b4 = [
    {
        path: "",
        component: "main-layout",
        children: [
            ...$2e71e547e293311f$export$d0079916fe6800ac
        ]
    }
];


const $4aa1cd84f89e5a94$export$5375cda95f0b0eb4 = new (0, $f9d9d110dea7aeee$export$55185c17a0fcbe46)(document.querySelector("#outlet"));
if (!$4aa1cd84f89e5a94$export$5375cda95f0b0eb4.location) {
    let loc = $4aa1cd84f89e5a94$export$5375cda95f0b0eb4.location;
    console.log($4aa1cd84f89e5a94$export$5375cda95f0b0eb4);
    console.log(loc);
    $4aa1cd84f89e5a94$export$5375cda95f0b0eb4.setRoutes((0, $2e71e547e293311f$export$66b32f6f30eb4b4));
//router.setRoutes(routes);
}
//router.setRoutes(routes);
const $4aa1cd84f89e5a94$var$notyf = new (0, $defa8edbc79437a8$export$146ebdf5fc143718)();
document.querySelector("#ca-address")?.addEventListener("click", ()=>{
    // Your copy logic here
    const textarea = document.createElement("textarea");
    textarea.value = document.querySelector("#ca-address").innerText.trim();
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
    // Show notification
    $4aa1cd84f89e5a94$var$notyf.success("Copied CA address to clipboard");
});


//# sourceMappingURL=index.c49f3efc.js.map
